(function ($) {
  "use strict";
  // Add class to Body for touch screen devices
  var getdeviceinfo = window.navigator.userAgent.toLowerCase()
  var touchdevicelist = ['webos','android','iphone','ipad','ipados','windows phone']

  // code to open and close the chatbot

  $(document).on('click', '.openchatbot',function(){
      if($('.iframe-container-chatbot').hasClass('active')) {
          $('.iframe-container-chatbot').removeClass('active')
      }
      else {
         $('.iframe-container-chatbot').addClass('active')
         $('.openchatbot').addClass('moving-icon')
      }
      if($('.openchatbot').hasClass('moving-icon')) {
        $('.openchatbot').removeClass('moving-icon')
        }
      else {
        $('.openchatbot').addClass('moving-icon')
      }
    });

   // code to open chatbot on specific utm parameters;
  if(window.location.href.includes('metachatbot')) {
    setTimeout(function () {
      if($('.iframe-container-chatbot').hasClass('active')) {
          $('.iframe-container-chatbot').removeClass('active')
      }
      else {
         $('.iframe-container-chatbot').addClass('active')
         $('.openchatbot').addClass('moving-icon')
      }
      if($('.openchatbot').hasClass('moving-icon')) {
        $('.openchatbot').removeClass('moving-icon')
        }
      else {
        $('.openchatbot').addClass('moving-icon')
      }
    },1500)
  }

  // code to get the device and store that into localstorage
    let userAgent = navigator.userAgent;
    $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://nibfs169v3.execute-api.us-east-2.amazonaws.com/production/getTheUserDeviceDetails`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers","Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "2nkkdbLZju4IRdT9yxtP06o9LaWo8SRLaymFpHJf");
        },
        data: JSON.stringify(userAgent),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      })
      .done(function(response) {
        //console.log("response",response)
         window.localStorage.setItem('device_data', JSON.stringify(response))
        //alert(response.os)
        let homePageSliderArray = document.querySelectorAll('.home-page-banner-slider')
        //console.log("homePageSliderArray",homePageSliderArray)
        homePageSliderArray.forEach((element)=> {
          let diviceArray = JSON.parse(element.getAttribute('os_array'))
          //console.log("diviceArray",diviceArray)
          if(diviceArray && diviceArray.includes(response.os.toLowerCase())) {
      
          }
          else {
             element.style.display="block";
          }
        })
      }).fail(function (error_in_ajax) {
        let homePageSliderArray = document.querySelectorAll('.home-page-banner-slider');
        homePageSliderArray.forEach((element) => {
            // In case of failure, you can still manipulate the element as needed
            // For instance, we might choose to leave all visible, or take a default action
            element.style.display = "block";  // Show the banners regardless of AJAX failure
        });
      }) 
  
  
  var affliliated_order = false;
  var non_affiliated_order = false;
  for(var i=0; i<touchdevicelist.length; i++){
    if (getdeviceinfo.includes(touchdevicelist[i])){
      var body_element = document.querySelector('body');
      body_element.classList.add('touch-device')
    }
  }

  if(!$('body').hasClass('touch-device')){
    $('.pd-show-img.zoom').zoom()
  } else {
    $('#activate_img_zoom').show()
  }

  // Magnify the image on load
  $(window).on('beforeunload', function() {
    $('body').hide();
    $(window).scrollTop(0);
  });

  // Script for Mobile Menu Activation
  $(document).ready(function () {
    $('.mobile-menu').on('click', function () {
      $('.offCanvasMenu, .off-canvas-overlay').addClass('active');
      $('body').addClass('nav-active');
    })

    $('.close-MobileMenu, .off-canvas-overlay').on('click', function () {
      $('.offCanvasMenu, .off-canvas-overlay').removeClass('active');
      $('body').removeClass('nav-active');
    })
  })

  // Script for Slick Slider Activation
  $('.pd-active').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="far fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });




  // Script for Slick Slider Activation, slick called on banner close on homepage
  $('.collection-active').slick({
    dots: false,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    padding: 60,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100,
    prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="far fa-angle-right"></i></button>',

  });

   // Script for Slick Slider Activation, slick called on Kiro Recircle page
  $('.recircle-active').slick({
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    padding: 60,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 6000,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100,
    prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="far fa-angle-right"></i></button>',

  });
 // slider for get the look on home page
  $('.home-active').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  prevArrow: '<button type="button" class="slick-prev coll-arrow-left" aria-label="previous"><i class="far fa-angle-left"></i></button>',
  nextArrow: '<button type="button" class="slick-next coll-arrow-right" aria-label="next"><i class="far fa-angle-right"></i></button>',
  responsive: [
     {
      breakpoint: 575,
      settings: {
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipe: true,
        arrows: true,
        centerMode: true,
        prevArrow: '<button type="button" class="slick-prev coll-arrow-left" aria-label="previous"><i class="far fa-angle-left" style=""></i></button>',
        nextArrow: '<button type="button" class="slick-next coll-arrow-right" aria-label="next"><i class="far fa-angle-right" style=""></i></button>'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        prevArrow: '<button type="button" class="slick-prev coll-arrow-left" aria-label="previous"><i class="far fa-angle-left" style=""></i></button>',
        nextArrow: '<button type="button" class="slick-next coll-arrow-right" aria-label="next"><i class="far fa-angle-right" style=""></i></button>'
      }
    }
  ]
});

  $('.product-display.cart-recommendation-slider').slick({
    infinite: false,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev cart-recommendation-slider-prev" aria-label="previous" style="left:5px;"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next cart-recommendation-slider-next" aria-label="next" style="right:5px;"><i class="far fa-angle-right"></i></button>',
    centerMode: false,
    responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 700,
          infinite: false
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          centerMode: false,
          arrows: false,
          speed: 700,
          arrows: true,
        }
      }
    ]	
});



// code to get currentTime 
  //   function getCurrentTime() {
  //     return new Date().getTime();
  //   }
  //   function updateStorage(startTime, totalTime) {
  //     sessionStorage.setItem('startTime', startTime);
  //     sessionStorage.setItem('totalTime', totalTime);
  //   }
  //   let startTime = sessionStorage.getItem('startTime') ? parseInt(sessionStorage.getItem('startTime'), 10) : getCurrentTime();
  //   let totalTime = sessionStorage.getItem('totalTime') ? parseInt(sessionStorage.getItem('totalTime'), 10) : 0;
  //   let totalTimeSpendOnWebisteSentOrNot = sessionStorage.getItem('totalTimeSend');

  //   // console.log("startTime",startTime);
  //   // console.log("totalTime",totalTime);
  //   // console.log("totalTimeSpendOnWebisteSentOrNot",totalTimeSpendOnWebisteSentOrNot);

  // //This function will runs when website is loaded 
  // window.addEventListener("load", (event) => {
  //   updateStorage(startTime, totalTime);
  //   if(totalTime < 10) {
  //     // this is the first time customer is visiting the website. After 10 seconds we will post this data to facebook pixels.
  //     let settimeout_duratation = (10 - totalTime)*1000;
  //     setTimeout(function() {
  //       const get_current_time = getCurrentTime();
  //       let differenceInMillis = get_current_time - startTime;
  //       // Convert milliseconds to seconds
  //       let differenceInSeconds = differenceInMillis / 1000;
  //       updateStorage(startTime, differenceInSeconds);
  //       //console.log("beforeunload is called",differenceInSeconds);
  //       // Code to be executed after the delay;
  //       if(!totalTimeSpendOnWebisteSentOrNot) {
  //        fbq('track', 'totalTimeSpend', {
  //         time_spend:differenceInSeconds
  //       });
  //       sessionStorage.setItem('totalTimeSend',true); 
  //       }
  //     }, settimeout_duratation); 
  //   }
  //   else {
  //     // customer is spending more than 10 seonds in our website we will post its data to facebook.
  //     // also try this fbq('trackCustom', 'totalTimeSpend').
  //     if(!totalTimeSpendOnWebisteSentOrNot) {
  //       fbq('track', 'totalTimeSpend', {
  //       time_spend:totalTime
  //     });
  //     sessionStorage.setItem('totalTimeSend',true);
  //     }
  //   }
  // });

  
  // //This function runs when you are about to leave the website or going to another page.
  // window.addEventListener('beforeunload', function () {
  //   const currentTime = getCurrentTime();
    
  //   let differenceInMillis = currentTime - startTime;
  //   // Convert milliseconds to seconds
  //   let differenceInSeconds = differenceInMillis / 1000;
  //   updateStorage(startTime, differenceInSeconds);
  //   console.log("beforeunload is called",differenceInSeconds);
  // });

  // code to trigger event to facebook if customer is there for more than 10 seconds into our website in one session.
  // code to get currentTime 
  //   function getCurrentTime() {
  //     return new Date().getTime();
  //   }
  //   function updateStorage(startTime, totalTime) {
  //     sessionStorage.setItem('startTime', startTime);
  //     sessionStorage.setItem('totalTime', totalTime);
  //   }
  //   let startTime = sessionStorage.getItem('startTime') ? parseInt(sessionStorage.getItem('startTime'), 10) : getCurrentTime();
  //   let totalTime = sessionStorage.getItem('totalTime') ? parseInt(sessionStorage.getItem('totalTime'), 10) : 0;
  //   let totalTimeSpendOnWebisteSentOrNot = sessionStorage.getItem('totalTimeSend');

  //   // console.log("startTime",startTime);
  //   // console.log("totalTime",totalTime);
  //   // console.log("totalTimeSpendOnWebisteSentOrNot",totalTimeSpendOnWebisteSentOrNot);

  // //This function will runs when website is loaded 
  // window.addEventListener("load", (event) => {
  //   updateStorage(startTime, totalTime);
  //   if(totalTime < 10) {
  //     // this is the first time customer is visiting the website. After 10 seconds we will post this data to facebook pixels.
  //     let settimeout_duratation = (10 - totalTime)*1000;
  //     setTimeout(function() {
  //       const get_current_time = getCurrentTime();
  //       let differenceInMillis = get_current_time - startTime;
  //       // Convert milliseconds to seconds
  //       let differenceInSeconds = differenceInMillis / 1000;
  //       updateStorage(startTime, differenceInSeconds);
  //       console.log("beforeunload is called",differenceInSeconds);
  //       // Code to be executed after the delay;
  //       if(!totalTimeSpendOnWebisteSentOrNot) {
  //        fbq('track', 'totalTimeSpend', {
  //         time_spend:differenceInSeconds
  //       });
  //       sessionStorage.setItem('totalTimeSend',true); 
  //       }
  //     }, settimeout_duratation); 
  //   }
  //   else {
  //     // customer is spending more than 10 seonds in our website we will post its data to facebook.
  //     // also try this fbq('trackCustom', 'totalTimeSpend').
  //     if(!totalTimeSpendOnWebisteSentOrNot) {
  //       fbq('track', 'totalTimeSpend', {
  //       time_spend:totalTime
  //     });
  //     sessionStorage.setItem('totalTimeSend',true);
  //     }
  //   }
  // });

  
  // //This function runs when you are about to leave the website or going to another page.
  // window.addEventListener('beforeunload', function () {
  //   const currentTime = getCurrentTime();
    
  //   let differenceInMillis = currentTime - startTime;
  //   // Convert milliseconds to seconds
  //   let differenceInSeconds = differenceInMillis / 1000;
  //   updateStorage(startTime, differenceInSeconds);
  //   console.log("beforeunload is called",differenceInSeconds);
  // });
  
 

  // Code for stopping video autoplaying.

  //   $(document).ready(function(){
  //     $(this).find('.product-video').get(0).pause()
  //   })

  // code for playing video on thumbnail click.




  //   $(document).ready(function () { 

  //     $('.gallery-nav-item').each(function(index, value) {
  //       console.log(index);
  //       console.log("test", value)
  //       //      var index_found = $(this).index();
  //       if(index == `${$('.gallery-nav-item').length-1}`)
  //       {
  //         index = `${$('.gallery-nav-item').length-1}`
  //         var index_found = index 
  //         console.log("Found",index_found)
  //         $(".gallery-nav-item").eq(index_found).addClass("image-click");
  //         console.log("True", index)
  //         $(".image-click").click(function(){
  //         $('.product-video').get(0).play()
  //         })
  //       }

  //     });
  //   });







  //   $(document).ready(function(){
  //     if($('body').hasClass('touch-device')){

  //       //     if($(".gallery-nav-item").hasClass('desktop')){

  //       //   else if($(".gallery-nav-item").hasClass('mobile')){

  //       $(document).ready(function () { 

  //         $('.gallery-nav-item.mobile').each(function(index, value) {
  //           console.log(index);
  //           console.log("test", value)
  //           //      var index_found = $(this).index();
  //           if(index == `${$('.gallery-nav-item.mobile').length-1}`)
  //           {
  //             index = `${$('.gallery-nav-item.mobile').length-1}`
  //             var index_found = index 
  //             console.log("Found",index_found)
  //             $(this).addClass("image-click");
  //             console.log("True", index)
  //             $(".image-click").click(function(){
  //               $('.product-video').get(0).play()
  //             })
  //           }

  //         });
  //       });
  //       //     }
  //       //     }
  //     }

  //     else {  $(document).ready(function () { 

  //       $('.desktop').each(function(index, value) {
  //         console.log(index);
  //         console.log("test", value)
  //         //      var index_found = $(this).index();
  //         if(index == `${$('.desktop').length-1}`)
  //         {
  //           index = `${$('.desktop').length-1}`
  //           var index_found = index 
  //           console.log("Found",index_found)
  //           $(".desktop").eq(index_found).addClass("image-click");
  //           console.log("True", index)
  //           $(".image-click").click(function(){
  //             $('.product-video').get(0).play()
  //           })
  //         }

  //       });
  //     });
  //          }   

  //   })


  // arr.forEach(function(i, idx, array){
  //    if (idx === array.length - 1){ 
  //        console.log("Last callback call at index " + idx + " with value " + i ); 
  //    }
  // });  

  //   $(document).ready(function () {

  //     $('.gallery-nav-item').find(function(){
  //     	$(' div img:last-child').addClass("image-click");

  //     })

  //   });



  // for preventing default form checkout.
  $("button.cart-checkout").click(function(e){
    e.preventDefault();
    window.location.href = $(".cart-checkout").attr("action");
    window.sessionStorage.setItem("hide_recommendation",false);
    hide_complete = false;
  })    

  // Query to display Terms and Condition Tabs
  var hash = window.location.hash;
  var page = window.location.pathname === '/pages/terms-and-conditions'
  if(page && hash !== undefined){
    $(hash).addClass('active');
    var faq_content = document.getElementById(hash.replace('#','')).nextElementSibling;
    if (faq_content.style.maxHeight) {
      faq_content.style.maxHeight = null;
    } else {
      faq_content.style.maxHeight = faq_content.scrollHeight + "px";
    }
    window.scrollBy(0,-50)
  }

  // Query For Showing Searchbox 
  $('#search').on('click', function () {
    $('.search-box').addClass('show');
  })
  $('.cls-sc-box').on('click', function () {
    $('.search-box').removeClass('show');
  })
  window.addEventListener('keyup', function (e) {
    if (e.keyCode === 13 || e.which === 13) {
      $('.search-box').removeClass('show');
    }
  })

  if(!window.location.pathname.includes('collections')){
    window.localStorage.removeItem('ingredient')
    $(document).on('click','.ingredient.action',function(e){
      var ingr = []
      window.localStorage.setItem('ingredient', JSON.stringify([$(this).attr('value')]))
    })
  }

  // Query For Change Input Type checkbox to radio 
  if(document.querySelector('.choose-color') !== null) {
    document.querySelectorAll('.choose-color input').forEach(function(each){
      each.setAttribute('type', 'radio');
      each.setAttribute('name', 'radioBtn');
    })
  }

  // Query to get customer chosen skintone from metafield
  $(document).ready(function(){
    var cust_id = $('.cust_init').attr('cid');
    if (cust_id !== undefined){
      var attr_val = $(".checkbx-wrapper").attr("value");
      if(attr_val){
        var attr_str = `[value=${attr_val}]`
        var $radios = $('input:checkbox[name=one]');
        if($radios.is(':checked') === false) {
          $radios.filter(attr_str).prop('checked', true);
        }
        var $cust_skintone = [attr_val]
        window.localStorage.setItem('skintone', JSON.stringify($cust_skintone))
      } else {
        if(window.localStorage.getItem('skintone')){
          if(!window.location.href.includes('/value-sets')){
            $(".check-search-wrap > p").text('Your selected skin tone is ')
          }
          var attr_str = `[value=${JSON.parse(window.localStorage.getItem('skintone'))[0]}]`
          if(!window.location.href.includes('value-sets')){
            var $radios = $('input:checkbox[name=one]');
            if($radios.is(':checked') === false) {
              $radios.filter(attr_str).prop('checked', true);
            }
          }
        }
      } 
    } else {
      if(window.localStorage.getItem('skintone')){
        if(!window.location.href.includes('/value-sets')){
          $(".check-search-wrap > p").text('Your selected skin tone is ')
        }
        var attr_str = `[value=${JSON.parse(window.localStorage.getItem('skintone'))[0]}]`
        if(!window.location.href.includes('value-sets')){
          var $radios = $('input:checkbox[name=one]');
          if($radios.is(':checked') === false) {
            $radios.filter(attr_str).prop('checked', true);
          }
        }
      }
    }
  });

  $(document).on('click','.ckBox', function(e){
    var $input = $(this).find('input')
    var $value = $(this).find('input').val()
    var $inputList = $('.ckBox').find('input')
    $inputList.each(function(){
      if($value != $(this).val()){
        $(this).prop('checked',false)
      }
    })
    var $skintone = [$value]

    if($input.is(':checked')){
      $(".check-search-wrap > p").text('Your selected skin tone is ')
      $('.show-ppp').addClass('show');
      if(!window.location.href.includes('/value-sets')){
        $('.header-area').addClass('skintone-tooltip');
      }
      window.localStorage.setItem('skintone', JSON.stringify($skintone))
    } else {
      $(".check-search-wrap > p").text('Select your skin tone for shade recommendations.')
      window.localStorage.removeItem('skintone')
      $('.show-ppp').removeClass('show');
      if(!window.location.href.includes('/value-sets')){
        $('.header-area').removeClass('skintone-tooltip');
      }
    }

    setTimeout(function(){
      $('.show-ppp').removeClass('show')
      $('.header-area').removeClass('skintone-tooltip');
    }, 10000);
  })

  $('.close-over-content').on('click', function () {
    $('.over-content').slideUp();
    $('.header-area').removeClass('skintone-tooltip');
    $('.show-ppp').removeClass('show')
  })

  // Query For Filter Popup 
  $('.for-filter').on('click', function (e) {
    e.preventDefault();
    $('.filter-content-wap').addClass('show');
    $('body').addClass('overflow');
  })

  $('.fil-heading i').on('click', function (e) {
    e.preventDefault();
    $('.filter-content-wap').removeClass('show');
    $('body').removeClass('overflow');
  })

  $(document).on('click','.bestseller-cart-btn', function (e) {
    e.preventDefault();
    // if($(this).hasClass('action')){
    //   $('#st-back-top').hide();
    //   $('.body-fade').addClass('active');
    //   $('.cartContent').addClass('show2');
    //   $('body').addClass('overflow')
    // }
  })

  $('.product-pge .cartsubmit').on('click', function (e) {
    e.preventDefault();
    $('.cartContent').addClass('show2');
    $('body').addClass('overflow')
  })

  $('.product-pge .add-wish').on('click', function (e) {
    e.preventDefault();
  })

  $('.wish-btn').on('click', function (e) {
    // console.log("wishlist class selected main.js")
    e.preventDefault();
    $('.offCanvasMenu, .off-canvas-overlay').removeClass('active');
    $('body').removeClass('nav-active');
    $('.wishContent').addClass('show2');
    $('body').addClass('overflow')
    $('.body-fade').addClass('active');
  })

  $('.close-wishlist').on('click', function (e) {
    e.preventDefault();
    $('.wishContent').removeClass('show2');
    $('body').removeClass('overflow')
    $('.body-fade').removeClass('active');
  })
  var clearSetTimoutFunction;
  var clearSetTimoutFunction2;
  var clearSetTimoutFunction3;
  // function closeCartIfEmpty() {
  //   // console.log('function is called')
  //   $.ajax({
  //     cache: false,
  //     async: false,
  //     url: `/cart.js`,
  //     dataType: "json",
  //     type: "GET",
  //     success: function(data) {
  //       if(data.items.length < 1) {
  //          // there no items in cart
  //       clearSetTimoutFunction = setTimeout(function(){
          
  //           if($('.cartContent').hasClass('show2')) {
  //             $('.cartContent').removeClass('show2');
  //           }
  //           if($('.body-fade').hasClass('active')) {
  //             $('.body-fade').removeClass('active');
  //           }
  //           if($('body').hasClass('overflow')) {
  //             $('body').removeClass('overflow');
  //           }
  //         }, 500)
  //       }
  //     }
  //   })
  // }

  // function closeCartIfEmptyForProducts() {
  //   // console.log('function is called for products')
  //          // there no items in cart
  //           if($('.cartContent').hasClass('show2')) {
  //             $('.cartContent').removeClass('show2');
  //           }
  //           if($('.body-fade').hasClass('active')) {
  //             $('.body-fade').removeClass('active');
  //           }
  //           if($('body').hasClass('overflow')) {
  //             $('body').removeClass('overflow');
  //           }
     
  // }
  
  $('.cart-btn').on('click', function (e) {
    e.preventDefault();
     $('.cartContent').addClass('show2');
    $('body').addClass('overflow')
    // clearSetTimoutFunction2 = setTimeout(function(){
    //   closeCartIfEmpty()
    // },2000)

  })

  $('.close-cart').on('click', function(e) {
    e.preventDefault();
    $('.cartContent').removeClass('show2');
    $('.body-fade').removeClass('active');
    $('body').removeClass('overflow')
    clearTimeout(clearSetTimoutFunction)
    clearTimeout(clearSetTimoutFunction2)
    // clearTimeout(clearSetTimoutFunction3)
  })

  // $(document).on('click','.addtocart',function(e){
  //   e.preventDefault();
  //   $('.cartContent').addClass('show2');
  //   $('body').addClass('overflow')
  // })
  
  $('.add-wish').on('click', function (e) {
    e.preventDefault();
  })
  $('.cartContent .fil-heading i').on('click', function (e) {
    e.preventDefault();
    $('.cartContent').removeClass('show2');
    $('body').removeClass('overflow')
  })

  $('.cart-pop-close').on('click', function (e) {
    e.preventDefault();
    $('.cartContent').addClass('show');
    $('body').removeClass('overflow')
  })

  if ($('#fp-nav ul li:nth-child(7) a').hasClass('active')) {
    $('.fp-right').hide();
  }

  function wish_count(){}

  function display_wish_slider_info(){
    var data = JSON.parse(window.localStorage.getItem("kvsl"));
    if(data.wishlist.length !== 0){
      $(".wish-empty").hide();
    } else if(data.wishlist.length === 0){
      $(".wish-empty").show();
    }
  }
  function display_product_added(){
    var $selector = $('.addtocart')
    var vid = $selector.attr('vid')
    var get_cart = JSON.parse(window.sessionStorage.getItem("kvsl"))
    var isInCart = get_cart.items.some(item =>(item.id === parseInt(vid)));

    if(isInCart){
      var line_item = get_cart.items.find(item =>(item.id === parseInt(vid)));
      if(line_item.quantity === 5){
        $selector.removeClass('action').addClass('disabled')
      } else if (line_item.quantity < 5){
        $selector.addClass('action').removeClass('disabled')
      }
    } else if(!isInCart) {
      $selector.hasClass('action') ? null: $selector.removeClass('disabled').addClass('action');	
    }
  }

  function display_cart_slider_info(){
    var data = JSON.parse(window.sessionStorage.getItem("kvsl"));
    if(data.items.length === 0){
      $(".cart-empty").show();
      $(".progressBr").hide();
      $(".checkout-form").hide();
      $(".cart-actions").hide();
      $(".offers-progressBr").hide();
    }else if(data.items.length !== 0){
      $(".cart-empty").hide();
      $(".progressBr").show();
      $(".checkout-form").show();
      $(".cart-actions").show();
      $(".offers-progressBr").show();
    }; 
  }
  function _asset_url(img){ 
    var src = $(".container-fluid").attr('value');
    return src.replace('s-1.png', img);
  }

  function render_cart_upsell(fields) {
    return null;

    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function(response) {
      if (httpRequest.readyState == XMLHttpRequest.DONE) {
        response = JSON.parse(httpRequest.responseText);
        var htmlCode = {
          child:`<div class="wish-pd">
<img src=${response.product.image.src} alt="">
</div>
<div class="wish-content">
<h4>Works well with!<br/>${response.product.title}<span class="hlk-bdr"></span></h4>
<div class="wish-btm-content">
<a href="/products/${response.product.handle}"><button class="box-btn">Shop</button></a>
</div>
</div>`
        }
        var newElement = document.createElement('div');
        var att = document.createAttribute("class");       
        att.value = "single-wish-product";                           
        newElement.setAttributeNode(att);

        newElement.innerHTML = htmlCode.child;
        $('.cart-upsell').html(newElement);
      } 
    }
    if (!httpRequest) {
      alert('Giving up :( Cannot create an XMLHTTP instance');
      return false;
    }
    var post_data = {action:"GET_PRODUCT", product_id:fields.cart_upsell.id}
    var get_cust_url = `https://rdq3y0otc0.execute-api.us-east-2.amazonaws.com/dev/metafield`;
    httpRequest.open('POST', get_cust_url);
    httpRequest.setRequestHeader("Access-Control-Allow-Origin", window.origin);
    httpRequest.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-Api-Key", "oIYMEyyUC83oBMoMdonCq3PVvCrQFQA774k3HsVs");
    httpRequest.send(JSON.stringify(post_data))  
  }

  function cart_upsell(id){
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function(response) {
      if (httpRequest.readyState == XMLHttpRequest.DONE) {
        response = JSON.parse(httpRequest.responseText);
        var index = response.metafields.findIndex(function(element, index){
          return (element.namespace === "product");
        });
        var fields = JSON.parse(response.metafields[index].value);
        var ie = JSON.parse(window.sessionStorage.getItem('kvsl'));
        var isProduct = ie.items.some(function(element, index){
          return (element.product_id === fields.cart_upsell.id)
        })  
        if(!isProduct){render_cart_upsell(fields)}
      }
    }
    if (!httpRequest) {
      alert('Giving up :( Cannot create an XMLHTTP instance');
      return false;
    }
    var post_data = {action:"GET_METAFIELD", product_id:id}
    var get_cust_url = `https://rdq3y0otc0.execute-api.us-east-2.amazonaws.com/dev/metafield`;
    httpRequest.open('POST', get_cust_url);
    httpRequest.setRequestHeader("Access-Control-Allow-Origin", window.origin);
    httpRequest.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-Api-Key", "oIYMEyyUC83oBMoMdonCq3PVvCrQFQA774k3HsVs");
    httpRequest.send(JSON.stringify(post_data))      
  }

  function display_shipment_progress_bar(subtotal){
    var min_value = parseInt($('.ful-progresss').attr('sh_limit'));
    var percent = Math.floor((subtotal / min_value) * 100);
    var diff = min_value - subtotal;
    if(percent >= 100){
      $('.ful-progresss').hide();
      $('p.free_shipment').html(`<span> You have received free shipment on this order. </span>`);
    } else if (percent === 0){
      $('.ful-progresss').hide();
    } else {
      $('.ful-progresss').show();
      $('.ful-progresss').children('span').attr(`style`,`width: ${percent}%`);
      $('p.free_shipment').html(`<span> &#8377; ${diff} away from free shipping.</span>`);
    }
  }

  // ---------------------------------------------------------- Pouch Eligibity ---------------------------------------------------- //


   var isDiscountActive = false;
   var discount_value = '';

  
  var get_affiliated = JSON.parse(window.localStorage.getItem('affiliate'))
  if(get_affiliated){
   
    var get_affiliate_date = new Date(get_affiliated.date)
    var nowdateObj = new Date()
    var diff_date = nowdateObj.getTime() - get_affiliate_date.getTime();
    var diff_day = diff_date / (1000 * 3600 * 24)
    if(parseInt(diff_day) > 0){
      window.localStorage.removeItem('affiliate')
    }
  }

  // store campagin in cookie we will use this to in custom pixel to not pass all the purase data;
  let utmURL = window.location.href;
  let urlParams = new URLSearchParams(utmURL.split('?')[1]); // Get everything after the "?"
  // Extract the utm_campaign value
  let utmCampaign = urlParams.get('utm_campaign');
  if (utmCampaign) {
    window.localStorage.setItem("utm_campaign",utmCampaign)
  }
  //OLD affiliates
 //var affiliated = ["collections/buy-3-at-1575","admitad","kofluence","vcommission","tier2","paytm","snap","ventestavenues","mdeal","u2opia","grabon","mediaxpedia","vpixup",
   //                "centralbelt","AC","ROI","whistlefeed","reddit","shopperswhatsapp","T2normalcollectionall","whatsapp250","lipbogo","dietsabya","CurlyKiro20"]
  
  var affiliated = ["collections/buy-3-at-1575","centralbelt","ROI","kwikchat","goaffpro","LipLoveExclusive","affalliances","lipstick_day_sale_jul2026","gift_bogo","mua_stories",
    "kiroskinmen","kiro-bogo-affiliate"
  ]
  var is_offer_source = false;
  for(i=0;i<affiliated.length;i++){
    if(window.location.href.includes(affiliated[i])){
      is_offer_source = true
    }
  }
  if(is_offer_source){
    var affiliate_source;
   if(window.location.href.includes('collections/buy-3-at-1575')){
      affiliate_source = 'buy-3'
    }
    else if(window.location.href.includes('centralbelt')){
      affiliate_source = 'centralbelt'
    }
    else if(window.location.href.includes('ROI')){
      affiliate_source = 'ROI'
    }
    else if(window.location.href.includes('kwikchat')){
      affiliate_source = 'kwikchat'
    }
    else if(window.location.href.includes('goaffpro')){
      affiliate_source = 'goaffpro'
    }
    else if(window.location.href.includes('lipstick_day_sale_jul2026')){
      affiliate_source = 'lipstick_day_sale_jul2026'
    }
    else if(window.location.href.includes('gift_bogo')){
      affiliate_source = 'gift_bogo'
    }
    else if(window.location.href.includes('mua_stories')){
      affiliate_source = 'mua_stories'
    }
    else if(window.location.href.includes('LipLoveExclusive')){
      affiliate_source = 'LipLoveExclusive'
    }
    else if(window.location.href.includes('affalliances')){
      affiliate_source = 'affalliances'
    }
    else if(window.location.href.includes('kiroskinmen')){
      affiliate_source = 'kiroskinmen'
    }
    else if(window.location.href.includes('kiro-bogo-affiliate')){
      affiliate_source = 'kiro-bogo-affiliate'
    }
    
    var dateObj = new Date()
    var payload = {"date": dateObj.toISOString(),"affilated": true, "source":affiliate_source}
    window.localStorage.setItem("affiliate", JSON.stringify(payload))
  }
  // var ISaffiliate_source_buy3 = JSON.parse(window.localStorage.getItem("affiliate"));
  var paytm_campaign = JSON.parse(window.localStorage.getItem("affiliate"));

  // console.log('paytm_campagin',paytm_campaign)


  if(paytm_campaign) {

    // if (paytm_campaign.source === "bogo") {
    //   console.log("testing done")
    //   const messages = [
    //       'Buy 1 product get another for free',
    //     ];

    //     $('.offer-text-slider p').each(function(index) {
    //       // cycle through messages array
    //       $(this).text(messages[index % messages.length]);
    //     });

    //   //   const $slider = $('.offer-slider-text-row');
    //   // if (!$slider.hasClass('slick-initialized')) return;

    //   // const messages = [
    //   //   '🎉 Buy 2 & Get 1 Free',
    //   //   '👜 Free Vegan Leather Bag on 2 Items'
    //   // ];

    //   // $('.offer-text-slider p').each(function (index) {
    //   //   $(this).text(messages[index % messages.length]);
    //   // });

    //   // requestAnimationFrame(function () {
    //   //   $slider.slick('setPosition');
    //   //   $slider.slick('slickSetOption', 'speed', 11000, false);
    //   // });
    //     $('.offers-tab').remove();
    // }
    // else if (paytm_campaign.source === "LipLoveExclusive") {
    //   console.log("testing done")
    //   const messages = [
    //       'Buy 2 products and get 25% off',
    //       'Buy 2 products and get a vegan bag free'
    //     ];

    //     $('.offer-text-slider p').each(function(index) {
    //       // cycle through messages array
    //       $(this).text(messages[index % messages.length]);
    //     });

    //     // $('.available-offer-message p').html('Exclusive Offer: Buy 1 lip product and get another for free with code <strong>LIPSTICKLOVE</strong>.');
    //     // $('.available-offer-message-span').attr('value', 'LIPSTICKLOVE');
    //     // $('.available-offer-message-span').attr('id', 'offer-product-LIPSTICKLOVE');
    //     // $('.available-offer-message-span').html('LIPSTICKLOVE');
    //     // $('.available-offer-message-span').html('LIPSTICKLOVE');
        
        
    //     // const $container = $('.specific.offers');
    //     //   // 2. Remove all existing content
    //     //   $container.empty();

    //     //   // 3. Define new offer details
    //     //   const newOfferText = 'Buy 1 lip product and get another for free with code LIPSTICKLOVE.';
    //     //   const newButtonValue = 'LIPSTICKLOVE';
    //     //   const newButtonText = 'LIPSTICKLOVE';
    //     //   const newSpanId = 'offer-product-LIPSTICKLOVE';

    //     //   // 4. Create new HTML for the offer
    //     //   const newOfferHTML = `
          
    //     //   <label style="width:100%;">
    //     //     <span class="available-offer-message" style="width:65%;float:left;padding-right:20px;">
    //     //       <p style="font-size:14px;line-height:15px;">${newOfferText}</p>
    //     //     </span>
    //     //     <span style="width:35%;float:right;">
    //     //       <span class="available-offer-message-span" style="display:none;" type="text" id="${newSpanId}" value="${newButtonValue}" readonly="">${newButtonValue}</span>
    //     //       <button class="copyClass product available-offer-message-btn" value="${newButtonValue}" style="font-size: 13px; background: #262626; color: #fff; outline: none; border: none; padding: 3px 5px; border-radius: 2px; float:left;">${newButtonText}</button>
    //     //     </span>
    //     //   </label>
    //     //   `;

    //     //   // 5. Append the new offer to the container
    //     //   $container.append(newOfferHTML);

    //     $('.offers-tab').remove();
    //     $('.offer.product.accordion.shade-finder-tab').css('border-bottom', '1px solid #000');
    // }



    // // console.log("affiliate_source",paytm_campaign)
    //  if(paytm_campaign.source === 'paytm') {
    // $('#free-shipping').css('display','none')
    //}
  }
    

       

        $(document).on('click','.awesome-btn',function(e){
           $('.offer-show-animation').html('')
        })



 
    var kiro_url = window.location.href;
  
    var hide_complete = false
      $(document).on('click','.recommended-product', function(e){
      $('.cart-recommedations').css('opacity','0')
      hide_complete = true;
      window.sessionStorage.setItem("hide_recommendation",true);
      })
  var temp_hide = window.sessionStorage.getItem("hide_recommendation");

  var discountOnCartArrayDublicate = [];

  var LipArr = ['non-stop','super-butter','lush-moist','lip-gloss','ph-play-lip-and-cheek-oil','lip-rizz-gloss','afterglow-lip-and-cheek-tint','wonder-wand-multi-stick-apricot-crush-02','wonder-wand-multi-stick-pink-chiffon-01',
               'wonder-wand-multi-stick-vintage-rose-03','wonder-wand-multi-stick-pink-opal-04','wonder-wand-multi-stick-celestial-glow-05','glossfinity-creme-gloss','slickstick-luxe-matte','ceramide-drip-tinted-lip-glaze',
              'velvet-souffle-soft-matte-liquid-lipstick','fleur-serum-lip-balm','ph-jelly-twist-colour-adapting-lip-balm','four-play-glossfinity-liquid-lipstick','shape-define-lip-liner'];
  var EyeArr = ['kajal','eye','mascara','eyeliner','wonder-wand-multi-stick'];
  var FaceArr = ['blush','highlighter','compact','foundation','wonder-wand'];
  var FaceArr2 = ['daily-dewy-serum-foundation-peachy-ivory-01','daily-dewy-serum-foundation-caramel-tan-04','daily-dewy-serum-foundation-sun-beige-02', 
                  'daily-dewy-serum-foundation-almond-beige-03', 'wonder-wand-multi-stick-apricot-crush-02', 'wonder-wand-multi-stick-pink-chiffon-01', 
                  'wonder-wand-multi-stick-vintage-rose-03', 'wonder-wand-multi-stick-pink-opal-04', 'wonder-wand-multi-stick-celestial-glow-05', 'wonder-wand-multi-stick-crushed-berry-06',
                  'wonder-wand-multi-stick-cherry-blossom-07', 'wonder-wand-multi-stick-terracotta-bloom-08', 'wonder-wand-multi-stick-pink-wink-09', 
                  'kiro-glow-on-the-go-3-in-1-highlighter-and-blush-celestial-dawn-01','kiro-glow-on-the-go-3-1-highlighter-blush-sundowner-spritz-02',
                  'just-rollin-face-sculpting-primer-au-naturel','barely-there-skin-tint-10c-light','barely-there-skin-tint-10w-light','barely-there-skin-tint-15c-light',
                  'barely-there-skin-tint-20c-light-medium','barely-there-skin-tint-20n-light-medium','barely-there-skin-tint-25w-light-medium',
                  'barely-there-skin-tint-37w-light-medium','barely-there-skin-tint-40w-medium','barely-there-skin-tint-40n-medium','barely-there-skin-tint-42c-medium',
                  'barely-there-skin-tint-45w-deep','barely-there-skin-tint-50w-deep','buff-blur-serum-concealer-150c-light','buff-blur-serum-concealer-200n-light',
                  'buff-blur-serum-concealer-250w-light-medium','buff-blur-serum-concealer-270n-light-medium','buff-blur-serum-concealer-300n-light-medium','buff-blur-serum-concealer-350w-medium',
                  'buff-blur-serum-concealer-400n-medium','buff-blur-serum-concealer-420c-medium','buff-blur-serum-concealer-440w-deep','buff-blur-serum-concealer-450w-deep','oh-my-glow-illuminating-moisturiser-with-spf-50-pa-pink-halo'
                ];

   var kajal = ["kajal-all-day-comfort-kajal-liner-carbon-black-01"];
    var liquidlip = [
      "non-stop-airy-matte-liquid-lip-venus-rose-11",
      "non-stop-airy-matte-liquid-lip-sandy-rose-13",
      "non-stop-airy-matte-liquid-lip-pink-salt-09",
      "non-stop-airy-matte-liquid-lip-pink-granite-08",
      "non-stop-airy-matte-liquid-lip-vintage-lotus-07",
      "non-stop-airy-matte-liquid-lip-tropical-fuschia-05",
      "non-stop-airy-matte-liquid-lip-scarlet-poppy-03",
      "non-stop-airy-matte-liquid-lip-pink-pepper-10",
      "non-stop-airy-matte-liquid-lip-ladybird-red-01",
      "non-stop-airy-matte-liquid-lip-dusky-grape-16",
      "non-stop-airy-matte-liquid-lip-cinnamon-nude-17",
      "non-stop-airy-matte-liquid-lip-nude-mocha-18",
      "non-stop-airy-matte-liquid-lip-peachy-nude-19",
      "non-stop-airy-matte-liquid-lip-nude-lily-20",
      "non-stop-airy-matte-liquid-lip-nutmeg-nude-12",
      "non-stop-airy-matte-liquid-lip-coral-pink-21",
      "non-stop-airy-matte-liquid-lip-nude-ginger-22",
      "non-stop-airy-matte-liquid-lip-maple-sugar-23",
      "non-stop-airy-matte-liquid-lip-nude-espresso-24",
      "non-stop-airy-matte-liquid-lip-rose-blush-25",
      "non-stop-airy-matte-liquid-lip-pink-dawn-26",
      "non-stop-airy-matte-liquid-lip-velvet-merlot-27",
      "non-stop-airy-matte-liquid-lip-sunset-nude-28",
      "non-stop-airy-matte-liquid-lip-barely-brown-29",
      "non-stop-airy-matte-liquid-lip-muted-orchid-30",
      "non-stop-airy-matte-liquid-lip-toffee-truffle-31",
      "non-stop-airy-matte-liquid-lip-sugar-petal-32",
      "non-stop-airy-matte-liquid-lip-berry-drizzle-36",
      "non-stop-airy-matte-liquid-lip-brown-sugar-38",
      "non-stop-airy-matte-liquid-lip-mauve-crush-35",
      "non-stop-airy-matte-liquid-lip-sienna-rouge-34",
      "non-stop-airy-matte-liquid-lip-smoky-taupe-37",
      "non-stop-airy-matte-liquid-lip-toasted-pink-33",
      "velvet-souffle-soft-matte-liquid-lipstick-suede-rosewood-01",
      "velvet-souffle-soft-matte-liquid-lipstick-rose-taupe-02",
      "velvet-souffle-soft-matte-liquid-lipstick-pink-truffle-03",
      "velvet-souffle-soft-matte-liquid-lipstick-terra-rose-04",
      "velvet-souffle-soft-matte-liquid-lipstick-rich-nutmeg-05",
      "velvet-souffle-soft-matte-liquid-lipstick-hazelnut-crush-06",
      "velvet-souffle-soft-matte-liquid-lipstick-plum-merlot-07",
      "velvet-souffle-soft-matte-liquid-lipstick-rusty-peony-08",
      "velvet-souffle-soft-matte-liquid-lipstick-cinnamon-sugar-09",
      "velvet-souffle-soft-matte-liquid-lipstick-crimson-cherry-10",
      "velvet-souffle-soft-matte-liquid-lipstick-persica-blossom-11",
      "velvet-souffle-soft-matte-liquid-lipstick-warm-caramel-12",
      "velvet-souffle-soft-matte-liquid-lipstick-pumpkin-spice-13",
      "velvet-souffle-soft-matte-liquid-lipstick-primrose-pink-14",
      "velvet-souffle-soft-matte-liquid-lipstick-carnival-red-15",
      "velvet-souffle-soft-matte-liquid-lipstick-rich-mocha-16"
    ]
  
     var isEyeProduct=['kajal','eye','shield-mascara']
     var isMakeupComboOrBundleProduct = ['build-your-own-bundle','makeup-combo','make-your-own-bundle','showstopper-kit-anniversary-edition']

    var makeupcombo = ["makeup-combo-drop-dead-gorgeous","bae-sic-nude-essentials","makeup-combo-strut-out-your-terrific-makeup",'showstopper-kit-anniversary-edition']
    var itBag_handle = ['it-bag']
    var vegan_bag_handle = ['vegan-leather-bag-pink','vegan-leather-bag-black','vegan-leather-bag-red']
    var makeup_remover_handle = ['clean-it-off-makeup-remover-100-ml']
    var dynamic_offer_handle = ['dynamic-offer-bundlee','deal-of-the-day','liquid-lip-and-kajal-combo']
    var eyeshadow_stick_handle= ['longwear-brightening-eyeshadow-stick-peachy-gold-01','longwear-brightening-eyeshadow-stick-sandy-copper-02','shadow-me-eyeshadow-palette-sand-dune-02']
    var eyeliner_pencil_handle = ['hi-def-soothing-eyeliner-pencil-sapphire-blue-01','hi-def-soothing-eyeliner-pencil-earth-brown-02']
    var theNudeKit_handle = ['the-nude-edit-light-to-medium','the-nude-edit-medium-to-deep']
    var serumFoundationHandle = ['daily-dewy-serum-foundation-peachy-ivory-01','daily-dewy-serum-foundation-almond-beige-03','daily-dewy-serum-foundation-pure-porcelain-05','daily-dewy-serum-foundation-caramel-tan-04',
                                 'daily-dewy-serum-foundation-rose-ivory-06','daily-dewy-serum-foundation-spiced-beige-07','daily-dewy-serum-foundation-hazel-nude-08','daily-dewy-serum-foundation-sun-beige-02']
    var superButterLipHandle = ['super-butter-lip-lacquer'];
    var payalSinghalProdHandle = ['non-stop-airy-matte-liquid-lip-coral-pink-21','non-stop-airy-matte-liquid-lip-nude-ginger-22','non-stop-airy-matte-liquid-lip-maple-sugar-23',
                                  'non-stop-airy-matte-liquid-lip-nude-espresso-24','non-stop-airy-matte-liquid-lip-rose-blush-25','non-stop-airy-matte-liquid-lip-pink-dawn-26']
    var psVanityPouchHandle = ['kiro-x-payal-singhal-vanity-pouch']
    var eyePalette = ['shadow-me-eyeshadow-palette-break-of-dawn-01','shadow-me-eyeshadow-palette-sand-dune-02'];
    var accessories_handle = ['vegan-leather-bag-pink','vegan-leather-bag-black','vegan-leather-bag-red','kiro-x-payal-singhal-vanity-pouch','essentials-pouch','scrunchies']
    var collagen_prod_handle=['yourhappy-collagen-fizz-pack-of-2-30-effervescent-tablets']
    var buy2at1299handle=['2-products-bundle']
    var canvaspouch_handle = ['essentials-pouch']
    var lust_moist_handle = ['lush-moist-matte-lipstick']
    var excludedProdHandle = ["brightening-hydrogel-under-eye-patches-fade-out"]
    var gelKajalHandle=['hyperlasting-gel-kajal-black-onyx']
    var SlickstickminiHandle=['mini-slickstick-luxe-matte-lipstick-nutty-nougat-03']
    var glossfinityCremeMinisProdHandle=['glossfinity-creme-gloss-minis-pink-petal-01']
    var stickonHolderHandle=['kiro-lip-glaze-stick-on-holder']
    var is2ProductKit_handle = ['2-products-kit']
    var lipGlazeProd_handle = ['ceramide-drip-tinted-lip-glaze-strawberry-gelato-01','ceramide-drip-tinted-lip-glaze-toasted-vanilla-02','ceramide-drip-tinted-lip-glaze-rich-pecan-03',
                               'ceramide-drip-tinted-lip-glaze-caramel-cookie-04','ceramide-drip-tinted-lip-glaze-berry-ganache-05','ceramide-drip-tinted-lip-glaze-choco-melt-06','ceramide-drip-tinted-lip-glaze-plum-delight-07','ceramide-drip-tinted-lip-glaze-acaiberry-mousse-08','ceramide-drip-tinted-lip-glaze-matcha-boba-09']
    var fourPlayProd_handle = ['four-play-non-stop-airy-matte-liquid-lip-supreme-quad','four-play-non-stop-airy-matte-liquid-lip-ultimate-quad','four-play-non-stop-airy-matte-liquid-lip-paramount-pink',
                               'four-play-non-stop-airy-matte-liquid-lip-dominant-red-quad','four-play-non-stop-airy-matte-liquid-lip-apex-brown-quad','four-play-non-stop-airy-matte-liquid-lip-pinnacle-quad','four-play-non-stop-airy-matte-liquid-lip-elite-berry-quad',
                              'four-play-glossfinity-liquid-lipstick-timeless-nude-brown-quad','four-play-glossfinity-liquid-lipstick-signature-nude-pink-quad']
    var skintintProd_handle = ['barely-there-skin-tint']                           
    var Eyestack_handle = ['3-in-1-eye-stack-bare-peach-matte-trio-01','3-in-1-eye-stack-nutty-brown-matte-metallic-trio-02','3-in-1-eye-stack-copper-pink-metallic-matte-trio-03','3-in-1-eye-stack-rose-pink-metallic-matte-trio-04']                           
    var gloss_bogo_handle = ["super-butter-lip-lacquer-stone-lily-1","super-butter-lip-lacquer-nude-nectar-2","super-butter-lip-lacquer-pink-apple-3","super-butter-lip-lacquer-nude-apricot-4",
                              "super-butter-lip-lacquer-dusty-rose-5","super-butter-lip-lacquer-maple-nude-6","super-butter-lip-lacquer-melted-caramel-7","super-butter-lip-lacquer-spiced-nutmeg-8",
                              "super-butter-lip-lacquer-mahogany-blush-9","super-butter-lip-lacquer-roasted-walnut-10","super-butter-lip-lacquer-rose-wood-11","super-butter-lip-lacquer-vintage-wine-12",
                              "hydra-bomb-plumping-lip-gloss-pink-guava-01","hydra-bomb-plumping-lip-gloss-peach-crush-02"]
    var lipRizzGloss_handle = ['lip-rizz-gloss-pop-my-berry-01','lip-rizz-gloss-rose-all-day-02','lip-rizz-gloss-spread-the-sparkle-03']
    var lipCheeckoil_handle = ['ph-play-lip-and-cheek-oil-cherry-nectar']
    var HydraMatte_handle = ['longwear-hydra-matte-lipstick-nectar-nude-01','longwear-hydra-matte-lipstick-cinnamon-latte','longwear-hydra-matte-lipstick-blush-dream-03','longwear-hydra-matte-lipstick-moonlight-mauve-04','longwear-hydra-matte-lipstick-apricot-whisper-05','longwear-hydra-matte-lipstick-twilight-kiss-06','longwear-hydra-matte-lipstick-blooming-tulip-07','longwear-hydra-matte-lipstick-toasted-nutmeg-08','longwear-hydra-matte-lipstick-velvet-ruby-09','longwear-hydra-matte-lipstick-classic-cinnamon-10']
    var lipliner_handle = ['shape-define-lip-liner-bare-rose-01',"shape-define-lip-liner-perfect-nude-02","shape-define-lip-liner-mauve-whisper-03","shape-define-lip-liner-nutmeg-latte-04","shape-define-lip-liner-cherry-mocha-05","shape-define-lip-liner-espresso-mist-06"]
    var lipRizzGlossFreeGift_handle = ['nude-ginger-soy-candle','tangle-ease-neem-comb','scrunchies','essentials-pouch']
    var scrunchies_handle = ['scrunchies']
    var ph_play_handle = ['ph-play-lip-and-cheek-oil-cherry-nectar']
    var buy2at999_handle = ['2-products-kit']
    var afterglowTint_handle = ['afterglow-lip-and-cheek-tint-beach-peach-01','afterglow-lip-and-cheek-tint-rose-apple-02','afterglow-lip-and-cheek-tint-raspberry-compote-03','afterglow-lip-and-cheek-tint-fuchsia-blaze-04']
    var glossfinityProd_handle = ['glossfinity-creme-gloss-pink-petal-01',"glossfinity-creme-gloss-smoked-plum-02","glossfinity-creme-gloss-blushing-apricot-03","glossfinity-creme-gloss-rose-petal-04",
                                 "glossfinity-creme-gloss-caramel-swirl-05","glossfinity-creme-gloss-nutty-nutmeg-06","glossfinity-creme-gloss-berry-burst-07","glossfinity-creme-gloss-cocoa-walnut-08"]
    var eyePatch_handle = ['brightening-hydrogel-under-eye-patches-fade-out']
    var glossfinityMinisProd_handle = ['glossfinity-creme-gloss-minis-absolute-kit','glossfinity-creme-gloss-minis-quintessential-kit']
    var waterproofEyelinerPen_handle = ['liquid-pen-eyeliner-waterproof-soft-matte-eyeliner-carbon-black-01']
    var slickstickProd_handle = ['slickstick-luxe-matte-rosewood-nude-02','slickstick-luxe-matte-nutty-nougat-03','slickstick-luxe-matte-velvet-nude-04','slickstick-luxe-matte-almond-latte-09','slickstick-luxe-matte-muted-petal-13','slickstick-luxe-matte-antique-rose-16','slickstick-luxe-matte-blushed-cocoa-18']
    var uptownRedBagProd_handle = ['the-uptown-girl-bag-red']
    var blushandGlowDuoKit_handle = ['wonder-wand-multi-stick-blush-and-glow-duo']
    var moisturiser_handle = ['oh-my-glow-illuminating-moisturiser-with-spf-50-pa-pink-halo']
    var paytmOfferProducts_handle = ['daily-dewy-serum-foundation-spiced-beige-07','daily-dewy-serum-foundation-rose-ivory-06','daily-dewy-serum-foundation-pure-porcelain-05','daily-dewy-serum-foundation-peachy-ivory-01',
                                    'daily-dewy-serum-foundation-hazel-nude-08','daily-dewy-serum-foundation-almond-beige-03']
    var redditOfferProducts_handle = ['daily-dewy-serum-foundation-spiced-beige-07','daily-dewy-serum-foundation-rose-ivory-06','daily-dewy-serum-foundation-pure-porcelain-05','daily-dewy-serum-foundation-hazel-nude-08']
    var paytmOffersBlushProduct_handle = ['glow-on-blush-duo-perfect-pink-fresh-grapefruit-02','glow-on-blush-duo-classic-coral-fresh-grapefruit-05']
    var paytmOffersHighlighterProduct_handle = ['highlighter-duo-prism-perfect-sandy-rose-pearly-bronze-01']
    var wonderWandProd_handle = ['wonder-wand-multi-stick-pink-chiffon-01','wonder-wand-multi-stick-apricot-crush-02','wonder-wand-multi-stick-vintage-rose-03','wonder-wand-multi-stick-pink-opal-04','wonder-wand-multi-stick-celestial-glow-05']
    var sculptingPrimerProd_handle = ['just-rollin-face-sculpting-primer-au-naturel']
    var excludedProductsForDynamicBundles_handle = ['four-play-non-stop-airy-matte-liquid-lip-ultimate-quad','four-play-non-stop-airy-matte-liquid-lip-supreme-quad','four-play-non-stop-airy-matte-liquid-lip-paramount-pink',
                                                    'four-play-non-stop-airy-matte-liquid-lip-dominant-red-quad','slickstick-luxe-matte-almond-butter-01','slickstick-luxe-matte-rosewood-nude-02','slickstick-luxe-matte-nutty-nougat-03',
                                                    'slickstick-luxe-matte-velvet-nude-04','slickstick-luxe-matte-pink-horizon-05','slickstick-luxe-matte-mauve-macaroon-06','slickstick-luxe-matte-rustic-cocoa-07',
                                                    'slickstick-luxe-matte-firecracker-red-08','glossfinity-creme-gloss-minis-absolute-kit','longwear-brightening-eyeshadow-stick-sandy-copper-02',
                                                    'glossfinity-creme-gloss-minis-quintessential-kit','just-rollin-face-sculpting-primer-au-naturel','shadow-me-eyeshadow-palette-break-of-dawn-01',
                                                    'shadow-me-eyeshadow-palette-sand-dune-02','longwear-brightening-eyeshadow-stick-peachy-gold-01'];
    var isMascaraProd_handle = ['botanico-super-shield-mascara-carbon-black-01'] 
    var glossfinity_handle = ['four-play-glossfinity-liquid-lipstick-timeless-nude-brown-quad','four-play-glossfinity-liquid-lipstick-signature-nude-pink-quad']

    var day_cream_handle = ['own-the-day-brightening-moisturiser-spf-50-pa']
    var night_cream_handle = ['the-great-unplug-overnight-cream']
    var cleanser_handle = ['come-clean-creamy-cleanser']
    var lip_liner_half_handle = ['shape-define-lip-liner-bare-rose-1','shape-define-lip-liner-perfect-nude-2','shape-define-lip-liner-mauve-whisper-3','shape-define-lip-liner-nutmeg-latte-4',
      'shape-define-lip-liner-cherry-mocha-5','shape-define-lip-liner-espresso-mist-6']

    var Bogo_products_handle = ["lush-moist-matte-lipstick-dusky-peach-03",
          "lush-moist-matte-lipstick-ginger-tea-05",
          "lush-moist-matte-lipstick-hibiscus-petal-11",
          "lush-moist-matte-lipstick-lunar-berry-09",
          "lush-moist-matte-lipstick-nude-garnet-06",
          "lush-moist-matte-lipstick-nude-rose-02",
          "lush-moist-matte-lipstick-red-beet-10",
          "lush-moist-matte-lipstick-spicy-cinnamon-08",
          "lush-moist-matte-lipstick-tulip-bloom-04",
          "lush-moist-matte-lipstick-warm-nutmeg-07",
          "lush-moist-matte-lipstick-lotus-dew-01",
          "slickstick-luxe-matte-almond-butter-01",
          "slickstick-luxe-matte-rosewood-nude-02",
          "slickstick-luxe-matte-nutty-nougat-03",
          "slickstick-luxe-matte-velvet-nude-04",
          "slickstick-luxe-matte-pink-horizon-05",
          "slickstick-luxe-matte-mauve-macaroon-06",
          "slickstick-luxe-matte-rustic-cocoa-07",
          "slickstick-luxe-matte-firecracker-red-08",
          "slickstick-luxe-matte-almond-latte-09",
          "slickstick-luxe-matte-nutmeg-toffee-10",
          "slickstick-luxe-matte-dusty-peach-11",
          "slickstick-luxe-matte-berry-mocha-12",
          "slickstick-luxe-matte-muted-petal-13",
          "slickstick-luxe-matte-smokey-plum-14",
          "slickstick-luxe-matte-clay-peach-15",
          "slickstick-luxe-matte-antique-rose-16",
          "slickstick-luxe-matte-chestnut-brown-17",
          "slickstick-luxe-matte-blushed-cocoa-18",
          "ph-jelly-twist-colour-adapting-lip-balm-sugar-cloud-01",
          "ph-jelly-twist-colour-adapting-lip-balm-midnight-berry-02",
          "ph-jelly-twist-colour-adapting-lip-balm-strawberry-glaze-03",
          "ph-jelly-twist-colour-adapting-lip-balm-grape-ice-04",
          "ph-jelly-twist-colour-adapting-lip-balm-toasted-praline-05",
           "fleur-serum-lip-balm-bare-tulip-01",
          "fleur-serum-lip-balm-carnation-blush-02",
          "fleur-serum-lip-balm-petunia-whisper-03",
          "fleur-serum-lip-balm-hibiscus-bloom-04",
          "fleur-serum-lip-balm-dahlia-petal-05",
          "fleur-serum-lip-balm-rusty-rose-06"
        ]
      var skin_products_handle = ['own-the-day-brightening-moisturiser-spf-50-pa','the-great-unplug-overnight-cream','come-clean-creamy-cleanser','feelin-alive-milky-toner',
                                  'soak-in-hydrating-serum-concentrate','moment-of-clarity-aha-bha-pha-peeling-solution'
                                ]
      var skin_mini_products_handle = ['oh-my-glow-mini-illuminating-moisturiser-with-spf-50-pa-5ml']
  
  // ---------------- CLAIM: confetti + B2G1 hint line ----------------
  var B2G1_HINT_TEXT = `Choose Your Free Product<br>To Avail The <strong>B2G1</strong> Offer`;
  var B2G1_HINT_LINK = '/collections/all';
  var isClaimPending = false; // set by cart Claim buttons, consumed in re_render_cart
  var wasTwoPaidNoClaim = false; // 2 paid products, gift not claimed: confetti only on entering this state, not on every re-render

  // Same markup as a cart line (sections/cart-rendering.liquid): gift image instead of the product image,
  // Shop All instead of the quantity buttons, no Remove. Image URL comes from Shopify Files via header.liquid.
  function showB2G1HintLine() {
    $('.b2g1-hint-item').remove();
    var giftImg = window.KIRO_FREE_GIFT_IMG
      ? `<img src="${window.KIRO_FREE_GIFT_IMG}" alt="Free gift">`
      : `<span class="b2g1-hint-icon">🔥</span>`;
    $('#cart-inner').append(`
      <div class="single-wish-product b2g1-hint-item">
        <div class="wish-pd">${giftImg}</div>
        <div class="wish-content">
          <div>
            <h4>${B2G1_HINT_TEXT}</h4>
          </div>
          <div class="wish-btm-content">
            <div class="quantity-selector">
              <a href="${B2G1_HINT_LINK}" class="b2g1-hint-link">Shop All &rarr;</a>
            </div>
          </div>
        </div>
      </div>
    `);
  }

  function fireClaimConfetti() {
    if (typeof confetti !== 'function') return;
    // Aim at the centre of the cart drawer; fixed canvas so scrolling the bag doesn't hide it
    var drawer = document.getElementById('cartContent');
    var rect = drawer ? drawer.getBoundingClientRect() : null;
    var originX = rect && rect.width ? (rect.left + rect.width / 2) / window.innerWidth : 0.5;
    confetti({
      particleCount: 150,
      spread: 120,
      origin: { x: originX, y: 0.3 },
      zIndex: 99999
    });
  }

  function display_pouch_elegibity(data){
    console.log("display_pouch_elegibity start",new Date())
    $('.b2g1-hint-item').remove();
    var prevTwoPaidNoClaim = wasTwoPaidNoClaim;
    wasTwoPaidNoClaim = false;
    var ISaffiliate = window.localStorage.getItem("affiliate");
    var count = data.item_count
    var cart_total_price = data.total_price / 100;
    

    //     functionality to apply offers on selected shades starts
    var isDiscountActive = false;
    var temp_cart_data = data.items;
    var isliquid_lip = false;
    var makeup_combo_handle = false;
    var isMakeupComboOrBundle = false;
    var isVegan_Bag = false;
    var isMakeupRemover = false;
    var isDyanamicOfferProd = false;
    var isEyeShadow_Stick = false;
    var isLip_Oil = false;
    var isLip_liner = false;
    var isEyeliner_Pencil = false;
    var isNudeKit = false;
    var isSerumFoundation = false;
    var isSuperButterLip = false;
    var isPayalSingleProd = false;
    var isPSVanityPouch = false;
    var isEyePalette = false;
    var isKajal = false;
    var isAccessories = false;
    var isCollagen = false;
    var isBuy2at1299 = false;
    var isCanvasPouch = false;
    var isLushMoist = false;
    var isExcludedProd = false;
    var isOverRideExclude = false;
    var isGelKajal = false;
    var isSlickstickmini = false;
    var isGlossfinityCremeMinisProd = false;
    var isstickonHolder = false;
    var isEyestackProd = false;
    var isFourPlayProd = false;
    var isHydraMatteProd = false;
    var isSkinTintProd = false;
    var islipGlazeProd = false;
    var isGlossBogo = false;
    var isLipRizzGloss = false;
    var isLipRizzFreeGift = false;
    var isScrunchies = false;
    var isPh_Play = false;
    var isbuy2at999 = false;
    var isAfterGlowTint = false;
    var isGlossfinityCremeProd = false;
    var isEyePatchProd = false;
    var isGlossfinityMinisProd = false;
    var isWaterpoofEyelinerPen = false;
    var isSlickstickProd = false;
    var isUptownRedBagProd = false;
    var isBlushandGlowDuoKit = false;
    var isMoisturiser = false;
    var isItBag = false;
    var isPaytmOfferProduct = false;
    var isRedditOfferProduct = false;
    var isPaytmOfferBlushProduct = false;
    var isPaytmOfferHighlighterProduct = false;
    var isWonderWandProd = false;
    var isSculptingPrimerProd = false;
    var isExludedProdForDynamicBundles = false;
    var isMascaraProd = false;
    var isFaceArr2 = false;
    var isGlossfinity_Four_Play = false;
    var isDayCream = false;
    var isNightCream = false;
    var isCleanser = false;
    var isLogged_in_customer = false;
    var isLip_Liner_Half = false;
    var isSkin = false;
    var isSkin_Mini = false;
    var Bogo_products = false;
    var isPrimer = false;
    
    var lip_count = 0;
    var lush_moist_count = 0;
    var selected_lip_count = 0;
    var eye_count = 0;
    var face_count= 0;
    var face_count1= 0;
    var itBag_quantity = 0;
    var lip_oil_count = 0;
    var lip_liner_count = 0;
    var slickstick_count = 0;
    var eyeshadow_stick_count = 0;
    var eyeliner_pencil_count = 0;
    var serumFoundation_count = 0;
    var superbutter_count = 0;
    var payalSinghalProd_count = 0;
    var eyePalette_count = 0;
    var gelKajal_count = 0;
    var glossfinityProd_count = 0;
    var stickonHolder_count = 0;
    var excluded_prod_count = 0;
    var excluded_prod_count_new = 0;
    var FourPlayProd_count = 0;
    var HydraMatteProd_count = 0;
    var SkintintProd_count = 0;
    var EyeStackProd_count = 0;
    var lipGlazeProd_count = 0;
    var gloss_bogo_count = 0;
    var lipRizzGloss_count = 0;
    var lipRizzGlossFreeGift_count = 0;
    var exludedProdForDynamicBundles_count = 0;
    var Bogo_products_count = 0;
    

    var discountOnCart_Array = []; 
    discountOnCartArrayDublicate = [];
    var product_recommend_list = [];
    
    var isLip=false,isEye=false,isFace=false;

    var value = window.localStorage.KWIKSESSIONTOKEN
    // if (value != "undefined" || value != undefined){
    //   isLogged_in_customer = true;
    // }
    // else{
    //   isLogged_in_customer = false
    // }

    console.log("isLogged_in_customer",isLogged_in_customer)


      if(temp_cart_data.length === 0){
        $('.cart-recommedations').css('opacity',0);
        // $('.cart-recommedations').hide();
      }
       for(i=0; i< temp_cart_data.length ; i++){
        var temp_handle = temp_cart_data[i].handle
        for(let j=0; j< LipArr.length ; j++){
          if(temp_handle.includes(LipArr[j])){
            isLip = true;
            lip_count += temp_cart_data[i].quantity;
            break;
          }
        }
        for(let j=0; j< EyeArr.length ; j++){
          if(temp_handle.includes(EyeArr[j])){
            isEye = true;
            eye_count += temp_cart_data[i].quantity;
            break;
          }
        }
        for(let j=0; j< FaceArr.length ; j++){
          if(temp_handle.includes(FaceArr[j])){
            isFace = true;
            face_count +=temp_cart_data[i].quantity;
            break;
          }
        }
        for(let j=0;j<skintintProd_handle.length;j++){
          if(temp_handle.includes(skintintProd_handle[j])){
            isSkinTintProd = true;
            SkintintProd_count +=temp_cart_data[i].quantity;
            break;
          }
        }
        for(let j=0;j<lust_moist_handle.length;j++){
          if(temp_handle.includes(lust_moist_handle[j])){
            isLushMoist = true;
            lush_moist_count +=temp_cart_data[i].quantity;
            break;
          }
        }
      }

    
    for(i=0; i< temp_cart_data.length ; i++){
      var temp_handle = temp_cart_data[i].handle  
      // excluding the kits or accessories products.
      if(i>=1){
        if(isExcludedProd === true)
        {
          if(excludedProdHandle.includes(temp_handle)){
            isExcludedProd = true;
            isOverRideExclude = true;
            
          }
          else{
             isExcludedProd = false;
             isOverRideExclude = false;
        
          }
        }
        else{
          
        }
      }
      else{
        if(excludedProdHandle.includes(temp_handle)){
            isExcludedProd = true;
            isOverRideExclude = true;
          }
          else{
             isExcludedProd = false;
            isOverRideExclude = false;
          }
      }
      
      if(liquidlip.includes(temp_handle)){
         selected_lip_count += temp_cart_data[i].quantity;
         isliquid_lip = true;
      }
      else if(vegan_bag_handle.includes(temp_handle)){
          isVegan_Bag = true;
        }
      
      else if(canvaspouch_handle.includes(temp_handle)){
          isCanvasPouch = true;
        }
      else if(FaceArr2.includes(temp_handle)){
          isFaceArr2 = true;
          face_count1 += temp_cart_data[i].quantity;
        }
      else if(lipRizzGloss_handle.includes(temp_handle)){
          isLipRizzGloss = true;
        }
      else if(skin_products_handle.includes(temp_handle)){
        isSkin = true;
      }
      else if(skin_mini_products_handle.includes(temp_handle)){
        isSkin_Mini = true;
      }

       else if(wonderWandProd_handle.includes(temp_handle)){
          isWonderWandProd = true;
        }
      else if(Bogo_products_handle.includes(temp_handle)){
        Bogo_products = true;
        Bogo_products_count += temp_cart_data[i].quantity;
      }
      else if(stickonHolderHandle.includes(temp_handle)){
          isstickonHolder = true;
        }
      else if(glossfinityCremeMinisProdHandle.includes(temp_handle)){
          console.log("assigned", glossfinityCremeMinisProdHandle.includes(temp_handle))
          isGlossfinityCremeMinisProd = true;
        }
      else if(gelKajalHandle.includes(temp_handle)){
          isGelKajal = true;
        }
      else if(SlickstickminiHandle.includes(temp_handle)){
          isSlickstickmini = true;
        } 
       else if(excludedProdHandle.includes(temp_handle)){
         excluded_prod_count += temp_cart_data[i].quantity; 
       }
      else if(lipGlazeProd_handle.includes(temp_handle)){
          islipGlazeProd = true;
          lipGlazeProd_count += temp_cart_data[i].quantity;
        }
      else if(skintintProd_handle.includes(temp_handle)){
          isSkinTintProd = true;
          SkintintProd_count += temp_cart_data[i].quantity;
        }
      else if(fourPlayProd_handle.includes(temp_handle)){
          isFourPlayProd = true;
          FourPlayProd_count += temp_cart_data[i].quantity;
        }
        else if(HydraMatte_handle.includes(temp_handle)){
          isHydraMatteProd = true;
          HydraMatteProd_count += temp_cart_data[i].quantity;
        }
      // else if(glossfinity_handle.includes(temp_handle)){
      //     isGlossfinity_Four_Play = true;
          
      //   }
      else if(eyeshadow_stick_handle.includes(temp_handle)){
          isEyeShadow_Stick = true;
           eyeshadow_stick_count = temp_cart_data[i].quantity;
        }
      else if(Eyestack_handle.includes(temp_handle)){
          isEyestackProd = true;
          EyeStackProd_count += temp_cart_data[i].quantity;
        }
      
      else if(lip_liner_half_handle.includes(temp_handle)){
          isLip_Liner_Half = true;;
        }
       else if(lipliner_handle.includes(temp_handle)){
          isLip_liner = true;
          lip_liner_count += temp_cart_data[i].quantity;
        }
      else if(lipliner_handle.includes(temp_handle)){
          isLip_liner = true;
          lip_liner_count += temp_cart_data[i].quantity;
        }
      else if(slickstickProd_handle.includes(temp_handle)){
          isSlickstickProd = true;
          slickstick_count += temp_cart_data[i].quantity;
        }
      else if(day_cream_handle.includes(temp_handle)){
          isDayCream = true;
         
        }
      else if(night_cream_handle.includes(temp_handle)){
          isNightCream = true;
   
        }
      else if(cleanser_handle.includes(temp_handle)){
          isCleanser = true;
         
        }
      // if(i>=1){
      //   if(isFaceSerum === true)
      //   {
      //     if(isFaceSerumProduct.includes(temp_handle)){
      //       isFaceSerum = true;

      //     }
      //     else{
      //        isFaceSerum = false;
  
      //     }
      //   }
      //   else{
          
      //   }
      // }
      // else{
      //   if(isFaceSerumProduct.includes(temp_handle)){
      //       isFaceSerum = true;
           
      //     }
      //     else{
      //        isFaceSerum = false;
      //     }
      // }
      if(excludedProductsForDynamicBundles_handle.includes(temp_handle)){
         isExludedProdForDynamicBundles = true;
         exludedProdForDynamicBundles_count += temp_cart_data[i].quantity; 
       }
      if(sculptingPrimerProd_handle.includes(temp_handle)){
          isPrimer = true;
        }
      // if(accessories_handle.includes(temp_handle)){
      //   isAccessories = true;
      // }
        
      else
      {
        // console.log("No Data Found")
      }
    }
      // ---------------- INIT ----------------
       
       console.log('isLip',isLip);
       console.log('lip_count',lip_count);
    
     if(ISaffiliate){
      var ISaffiliate_json = JSON.parse(window.localStorage.getItem("affiliate"));
       // if(ISaffiliate_json.source === 'buy-3') {
       //    window.localStorage.removeItem('affiliate')
       // }


       
      if(count === 0){
        $('.diwali-pouch-display.active').html(``)
        // $('.new-cart-upsell').html(``)
        $('.new-cart-upsell-temp').hide()
        $('.new-cart-upsell').hide()
        $('.new-cart-upsell.non-aff').hide()
        $('.new-cart-upsell-temp-canvas').hide();
        
      }
        else if(ISaffiliate_json.source === 'buy-3'){
          if(count >=1 && isDyanamicOfferProd === true ) {
              $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"></span>`)
              $('.new-cart-upsell.non-aff').hide()
              $('.new-cart-upsell-temp').hide()
            }
            else if(count ===1 && isNudeKit === true ) {
              $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"></span>`)
              $('.new-cart-upsell.non-aff').hide()
              $('.new-cart-upsell-temp').hide()
            }
            else if(count >=1 && isNudeKit === true) {
              $('.diwali-pouch-display.active').html(``)
              $('.new-cart-upsell.non-aff').hide()
              $('.new-cart-upsell-temp').hide()
            }
           else if(count ===1 && isMakeupComboOrBundle === true) {
              $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"></span>`)
              $('.new-cart-upsell.non-aff').hide()
              $('.new-cart-upsell-temp').hide()
            }
            else if(count >=1 && isMakeupComboOrBundle === true) {
              $('.diwali-pouch-display.active').html(``)
              $('.new-cart-upsell.non-aff').hide()
              $('.new-cart-upsell-temp').hide()
            }
              else if(count >= 1 ){
              $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Buy 3 products just for Rs. 1575. <a href="/collections/buy-3-at-1575" style="color:#000;" aria-label="buy-3-at-1575"> Click here</a> to select your favorite products.</span>`)
              $('.new-cart-upsell.non-aff').hide()
              $('.new-cart-upsell-temp').hide()
              $('.new-cart-upsell-temp-canvas').hide()
              $('.new-cart-upsell-desk-offer').hide()
              
            }
        }
      
      
      else if(ISaffiliate_json.source === 'kwikchat'){

          
        if(excluded_prod_count > 0) {
            count = count - excluded_prod_count ;
        }
        if(count === 0){
                    $('.diwali-pouch-display.active').html(``)
                    $('.new-cart-upsell').hide()
                    $('.new-cart-upsell-temp').hide();
                    $('.new-cart-upsell-temp-mascara').hide();
                    $('.new-cart-upsell.non-aff').hide();
                    $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
                    $('.cart-recommedations').css('opacity','0');
                    $('.new-cart-upsell-temp-eye-patch').hide();
                    $('.new-cart-upsell.non-aff-foundation').hide();
                    $('.new-cart-upsell .single-wish-product.cart').hide();
                    $('.new-cart-upsell.non-aff-super-butter').hide();
                    $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
                    $('.new-cart-upsell.non-aff-stack').hide();
                    $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
                    $('.new-cart-upsell.non-aff-vegan-bag').hide();
                    $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
                    isDiscountActive = false;
        
        }
        else if(count >=1 && isExcludedProd === true ) {
          $('.diwali-pouch-display.active').html(``)
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
        }
        else if(count === 1 && isExcludedProd === false && isBuy2at1299 === false ) {
            $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Add 1 more product and get another product with lower MRP for free.</span>`)
            $('.new-cart-upsell.non-aff').hide();
            $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell-temp').hide();
            $('.new-cart-upsell-temp-eye-patch').hide();
            $('.new-cart-upsell-temp-mascara').hide();
            $('.cart-recommedations').css('opacity','0');
            $('.new-cart-upsell .single-wish-product.cart').hide();
            $('.new-cart-upsell.non-aff-foundation').hide();
            $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell.non-aff-super-butter').hide();
            $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell.non-aff-stack').hide();
            $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell.non-aff-vegan-bag').hide();
            $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
            isDiscountActive = false;
            RemoveDiscountCodeFromCookie();
         }
        else if(count >= 2 && isExcludedProd === false && isBuy2at1299 === false) {
            $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"></span>`)
            $('.new-cart-upsell.non-aff').hide();
            $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell-temp').hide();
            $('.new-cart-upsell-temp-eye-patch').hide();
            $('.new-cart-upsell-temp-mascara').hide();
            $('.cart-recommedations').css('opacity','0');
            $('.new-cart-upsell .single-wish-product.cart').hide();
            $('.new-cart-upsell.non-aff-foundation').hide();
            $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell.non-aff-super-butter').hide();
            $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell.non-aff-stack').hide();
            $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
            $('.new-cart-upsell.non-aff-vegan-bag').hide();
            $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
           isDiscountActive = false;
           RemoveDiscountCodeFromCookie();
         }
         
      }
      
      // else if(ISaffiliate_json.source === 'goaffpro'){

      //   function init(){

      //     const $container = $("#steps")
      //     $container.html("")

      //     const total = ACTIVE_OFFERS.length
      //     const segment = 100 / total

      //     $.each(ACTIVE_OFFERS, function(index, offer){

      //       offer.threshold = segment * (index + 1)

      //       const $div = $(`
      //         <div class="step" id="${offer.id}" style="left:${index + 1 === total ?96 : offer.threshold}%">
      //           <div class="icon">${offer.icon}</div>
      //           <div class="label">${offer.label}</div>
      //         </div>
      //       `)

      //       $container.append($div)
      //     })
      //   }

      //   // ---------------- VISUAL PROGRESS ----------------
      //   const ALL_OFFERS = [
      //     { id:"flat10", label:"Flat 10", icon:"🏷️" },
      //     { id:"flat35", label:"Flat 35", icon:"🔥" }
      //   ]
      //   const ACTIVE_OFFERS = [...ALL_OFFERS]
      //   let progress = 0
      //   function getVisualProgress(raw){

      //     let prev = 0

      //     for(let i=0; i<ACTIVE_OFFERS.length; i++){

      //       const curr = ACTIVE_OFFERS[i].threshold

      //       if(raw < curr){

      //         const segmentSize = curr - prev
      //         const inside = raw - prev
      //         const ratio = inside / segmentSize

      //         return prev + (ratio * segmentSize)
      //       }

      //       prev = curr
      //     }

      //     return 100
      //   }

      //   // ---------------- UPDATE ----------------
      //   function update(){

      //     const visual = getVisualProgress(progress)
      //     $("#fill").css("width", visual + "%")

      //     let msg = ""

      //     for(let i=0; i<ACTIVE_OFFERS.length; i++){

      //       const offer = ACTIVE_OFFERS[i]
      //       const $el = $("#" + offer.id)

      //       $el.removeClass("active")

      //       if(progress >= offer.threshold){
      //         $el.addClass("active")
      //       } else {
      //         $el.addClass("active")

      //         const diff = Math.ceil(offer.threshold - progress)
      //         msg = `You're ${diff}% away from ${offer.label}`
      //         break
      //       }
      //     }

      //     if(progress >= 100){
      //       msg = "All offers reached 🎯"
      //     }

      //     $("#msg").text(msg)
      //   }

      //   // ---------------- 🔥 GLOW (MANUAL ONLY) ----------------
      //   function activateOffer(offerId){

      //     // glow ONLY selected offer
      //     $(".step").removeClass("unlocked") // remove if single glow needed
      //     $("#" + offerId).addClass("unlocked")
      //   }

      //   // ---------------- 🎉 ANIMATION ----------------
      //   function fireConfetti(parentSelector) {
      //   const parent = document.querySelector(parentSelector);

      //   // create canvas dynamically
      //   const canvas = document.createElement('canvas');

      //   Object.assign(canvas.style, {
      //     position: 'absolute',
      //     top: 0,
      //     left: 0,
      //     width: '100%',
      //     height: '100%',
      //     pointerEvents: 'none',
      //     zIndex: 9999
      //   });

      //   parent.appendChild(canvas);

      //   const myConfetti = confetti.create(canvas, {
      //     resize: true,
      //     useWorker: true
      //   });

      //   myConfetti({
      //     particleCount: 150,
      //     spread: 120,
      //     origin: { y: 0.3 }
      //   });

      //   // remove canvas after animation
      //   setTimeout(() => {
      //     canvas.remove();
      //   }, 2500);
      // }
      //   function showOfferAnimation(label){

      //     let offers_html = `<div class="offer-show-animation-model">
      //               <div class="offers-percentage-icon">
      //                 <img src="https://cdn.shopify.com/s/files/1/0089/0893/1152/files/offers-percentage-image.png?v=1776325790">
      //               </div>
      //               <h2>Woohoo!</h2>
      //               <div class="offers-divider">
      //                 <span>★</span>
      //               </div>

      //               <p class="message">${label}</p>

      //               <button class="awesome-btn">AWESOME</button>
      //             </div>`
          
      //     $(".offer-show-animation").html(offers_html)
      //     fireConfetti("#cart-inner-div-dnd")
      //     // confetti({
      //     //   particleCount:120,
      //     //   spread:90
      //     // })

      //     setTimeout(function(){
      //       $('.offer-show-animation').html('')
      //     }, 2500)
      //   }

      //   // ---------------- ACTIONS ----------------
      //   function setProgress(val){
      //     progress = val
      //     update()
      //   }

      //   function setOffers(count){

      //     ACTIVE_OFFERS = ALL_OFFERS.slice(0, count)

      //     progress = 0

      //     init()
      //     update()
      //   }
      //    $(document).ready(function(){
      //     init()
      //     update()
      //   })

      //   if(excluded_prod_count > 0) {
      //       count = count - excluded_prod_count ;
      //   }
      //   if(count === 0){
      //     $('.diwali-pouch-display.active').html(``)
      //     $('.new-cart-upsell').hide()
      //     $('.new-cart-upsell-temp').hide();
      //     $('.new-cart-upsell-temp-gloss-minis').hide();
      //     $('.new-cart-upsell-temp-gel-kajal').hide();
      //     $('.new-cart-upsell-temp-lip-glaze').hide();
      //     $('.new-cart-upsell-temp-mascara').hide();
      //     $('.new-cart-upsell.non-aff').hide();
      //     $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
      //     $('.cart-recommedations').css('opacity','0');
      //     $('.new-cart-upsell-temp-eye-patch').hide();
      //     $('.new-cart-upsell.non-aff-foundation').hide();
      //     $('.new-cart-upsell .single-wish-product.cart').hide();
      //     $('.new-cart-upsell.non-aff-super-butter').hide();
      //     $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-stack').hide();
      //     $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-vegan-bag').hide();
      //     $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
      //     $('.free-skin-sample-products.day-cream-sample-product').hide();
      //     $('.free-skin-sample-products.night-cream-sample-product').hide();
      //     $('.free-skin-sample-products.cleanser-sample-product').hide();
      //     isDiscountActive = false;
      //     setProgress(0);
          
      //   }
      //   else if(count >=1 && isExcludedProd === true ) {
      //     $('.diwali-pouch-display.active').html(``)
      //     $('.new-cart-upsell.non-aff').hide();
      //     $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell-temp').hide();
      //     $('.new-cart-upsell-temp-gel-kajal').hide();
      //     $('.new-cart-upsell-temp-gloss-minis').hide();
      //     $('.new-cart-upsell-temp-lip-glaze').hide();
      //     $('.new-cart-upsell-temp-eye-patch').hide();
      //     $('.new-cart-upsell-temp-mascara').hide();
      //     $('.cart-recommedations').css('opacity','0');
      //     $('.new-cart-upsell .single-wish-product.cart').hide();
      //     $('.new-cart-upsell.non-aff-foundation').hide();
      //     $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-super-butter').hide();
      //     $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-slickstick').hide();
      //     $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-lip-oil').hide();
      //     $('.new-cart-upsell.non-aff-lip-oil .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-stack').hide();
      //     $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
      //     $('.new-cart-upsell.non-aff-vegan-bag').hide();
      //     $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
      //     $('.free-skin-sample-products.day-cream-sample-product').hide();
      //     $('.free-skin-sample-products.night-cream-sample-product').hide();
      //     $('.free-skin-sample-products.cleanser-sample-product').hide();
      //     isDiscountActive = false;
      //     RemoveDiscountCodeFromCookie();
      //     setProgress(0);
      //   }
      //    else if(count === 1 && isExcludedProd === false && isBuy2at1299 === false) {
      //       $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"></span>`)
      //       $('.add-more-product-text.banner__title.offer-message').html(`Buy 1 product and get Flat 10% off on all products.`);
      //       $('.add-more-product-text.banner__title.next-offer-message').html(`You're 1 product away from 35% off your order.`);
      //       $('.new-cart-upsell.non-aff').hide();
      //       $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell-temp').hide();
      //       $('.new-cart-upsell-temp-eye-patch').hide();
      //       $('.new-cart-upsell-temp-gel-kajal').hide();
      //       $('.new-cart-upsell-temp-mascara').hide();
      //       $('.cart-recommedations').css('opacity','0');
      //       $('.new-cart-upsell .single-wish-product.cart').hide();
      //       $('.new-cart-upsell.non-aff-foundation').hide();
      //       $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-super-butter').hide();
      //       $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-stack').hide();
      //       $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-wonder-wand .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-wonder-wand').hide();
      //       $('.new-cart-upsell.non-aff-lip-rizz').hide();
      //       $('.new-cart-upsell.non-aff-lip-rizz .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-lip-liner').hide();
      //       $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-vegan-bag').hide();
      //       $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
      //       $('.free-skin-sample-products.day-cream-sample-product').hide();
      //       $('.free-skin-sample-products.night-cream-sample-product').hide();
      //       $('.free-skin-sample-products.cleanser-sample-product').hide();
      //       isDiscountActive = false;
      //       RemoveDiscountCodeFromCookie();
      //       setProgress(50);
      //       activateOffer('flat10');
      //       showOfferAnimation('🔥 Buy any 1 product and get Flat 10% off on your order.');
      //   }
      //    else if(count >= 2 && isExcludedProd === false && isBuy2at1299 === false) {
      //       $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Offer Unlocked! Buy Any 1 Lip Product & Get 1 Lip Liner worth Rs.600 for Free. Apply your code at checkout</span>`)
      //       $('.add-more-product-text.banner__title.offer-message').html(`Buy 2 products and get Flat 35% off on all products.`);
      //       $('.add-more-product-text.banner__title.next-offer-message').html(``);
      //       $('.new-cart-upsell.non-aff').hide();
      //       $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell-temp').hide();
      //       $('.new-cart-upsell-temp-eye-patch').hide();
      //       $('.new-cart-upsell-temp-gel-kajal').hide();
      //       $('.new-cart-upsell-temp-mascara').hide();
      //       $('.cart-recommedations').css('opacity','0');
      //       $('.new-cart-upsell .single-wish-product.cart').hide();
      //       $('.new-cart-upsell.non-aff-foundation').hide();
      //       $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-super-butter').hide();
      //       $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-stack').hide();
      //       $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-lip-rizz .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-lip-rizz').hide();
      //       $('.new-cart-upsell.non-aff-lip-liner').hide();
      //       $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-wonder-wand .single-wish-product.show-cart-upsell').hide();
      //       $('.new-cart-upsell.non-aff-wonder-wand').hide();
      //       $('.new-cart-upsell.non-aff-vegan-bag').hide();
      //       $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
      //       $('.free-skin-sample-products.day-cream-sample-product').hide();
      //       $('.free-skin-sample-products.night-cream-sample-product').hide();
      //       $('.free-skin-sample-products.cleanser-sample-product').hide();
      //       isDiscountActive = false;
      //       RemoveDiscountCodeFromCookie();
      //       setProgress(96);
      //       activateOffer('flat35');
      //       showOfferAnimation('🔥 Buy any 2 products and get Flat 35% off on your order.');
      //    }
        
      // }    
      else if(ISaffiliate_json.source === 'mua_stories'){

        function init(){

          const $container = $("#steps")
          $container.html("")

          const total = ACTIVE_OFFERS.length
          const segment = 100 / total

          $.each(ACTIVE_OFFERS, function(index, offer){

            offer.threshold = segment * (index + 1)

            const $div = $(`
              <div class="step" id="${offer.id}" style="left:${index + 1 === total ?96 : offer.threshold}%">
                <div class="icon">${offer.icon}</div>
                <div class="label">${offer.label}</div>
              </div>
            `)

            $container.append($div)
          })
        }

        // ---------------- VISUAL PROGRESS ----------------
        const ALL_OFFERS = [
          { id:"bogo", label:"BOGO", icon:"🔥" }
        ]
        const ACTIVE_OFFERS = [...ALL_OFFERS]
        let progress = 0
        function getVisualProgress(raw){

          let prev = 0

          for(let i=0; i<ACTIVE_OFFERS.length; i++){

            const curr = ACTIVE_OFFERS[i].threshold

            if(raw < curr){

              const segmentSize = curr - prev
              const inside = raw - prev
              const ratio = inside / segmentSize

              return prev + (ratio * segmentSize)
            }

            prev = curr
          }

          return 100
        }

        // ---------------- UPDATE ----------------
        function update(){

          const visual = getVisualProgress(progress)
          $("#fill").css("width", visual + "%")

          let msg = ""

          for(let i=0; i<ACTIVE_OFFERS.length; i++){

            const offer = ACTIVE_OFFERS[i]
            const $el = $("#" + offer.id)

            $el.removeClass("active")

            if(progress >= offer.threshold){
              $el.addClass("active")
            } else {
              $el.addClass("active")

              const diff = Math.ceil(offer.threshold - progress)
              msg = `You're ${diff}% away from ${offer.label}`
              break
            }
          }

          if(progress >= 100){
            msg = "All offers reached 🎯"
          }

          $("#msg").text(msg)
        }

        // ---------------- 🔥 GLOW (MANUAL ONLY) ----------------
        function activateOffer(offerId){

          // glow ONLY selected offer
          $(".step").removeClass("unlocked") // remove if single glow needed
          $("#" + offerId).addClass("unlocked")
        }

        // ---------------- 🎉 ANIMATION ----------------
        function fireConfetti(parentSelector) {
        const parent = document.querySelector(parentSelector);

        // create canvas dynamically
        const canvas = document.createElement('canvas');

        Object.assign(canvas.style, {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 9999
        });

        parent.appendChild(canvas);

        const myConfetti = confetti.create(canvas, {
          resize: true,
          useWorker: true
        });

        myConfetti({
          particleCount: 150,
          spread: 120,
          origin: { y: 0.3 }
        });

        // remove canvas after animation
        setTimeout(() => {
          canvas.remove();
        }, 2500);
      }
        function showOfferAnimation(label){

          let offers_html = `<div class="offer-show-animation-model">
                    <div class="offers-percentage-icon">
                      <img src="https://cdn.shopify.com/s/files/1/0089/0893/1152/files/offers-percentage-image.png?v=1776325790">
                    </div>
                    <h2>Woohoo!</h2>
                    <div class="offers-divider">
                      <span>★</span>
                    </div>

                    <p class="message">${label}</p>

                    <button class="awesome-btn">AWESOME</button>
                  </div>`
          
          $(".offer-show-animation").html(offers_html)
          fireConfetti("#cart-inner-div-dnd")
          // confetti({
          //   particleCount:120,
          //   spread:90
          // })

          setTimeout(function(){
            $('.offer-show-animation').html('')
          }, 2500)
        }

        // ---------------- ACTIONS ----------------
        function setProgress(val){
          progress = val
          update()
        }

        function setOffers(count){

          ACTIVE_OFFERS = ALL_OFFERS.slice(0, count)

          progress = 0

          init()
          update()
        }
         $(document).ready(function(){
          init()
          update()
        })

        if(excluded_prod_count > 0) {
            count = count - excluded_prod_count ;
        }
        if(count === 0){
          $('.diwali-pouch-display.active').html(``)
          $('.new-cart-upsell').hide()
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          setProgress(0);
          
        }
        else if(count >=1 && isExcludedProd === true ) {
          $('.diwali-pouch-display.active').html(``)
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-oil').hide();
          $('.new-cart-upsell.non-aff-lip-oil .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
          setProgress(0);
        }
        else if(count === 1 && isExcludedProd === false && isBuy2at1299 === false) {
          $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Add 1 more product and get another product with lower MRP for free.</span>`)
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-oil').hide();
          $('.new-cart-upsell.non-aff-lip-oil .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
          setProgress(50);
        }
        else if(count >= 2 && isExcludedProd === false && isBuy2at1299 === false) {
          $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"><strong>Offer Unlocked! </strong>Buy 1 product and get another product with lower MRP for free. Use your discount code at checkout.</span>`)
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-oil').hide();
          $('.new-cart-upsell.non-aff-lip-oil .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
            setProgress(100);
            activateOffer('bogo');
            showOfferAnimation('🔥 BOGO Offer Unlocked! Buy 1 and Get 1 FREE for a limited time only.');
        }
      
      }
      else if(ISaffiliate_json.source === 'goaffpro'){

        function init(){

          const $container = $("#steps")
          $container.html("")

          const total = ACTIVE_OFFERS.length
          const segment = 100 / total

          $.each(ACTIVE_OFFERS, function(index, offer){

            offer.threshold = segment * (index + 1)

            const $div = $(`
              <div class="step" id="${offer.id}" style="left:${index + 1 === total ?96 : offer.threshold}%">
                <div class="icon">${offer.icon}</div>
                <div class="label">${offer.label}</div>
              </div>
            `)

            $container.append($div)
          })
        }

        // ---------------- VISUAL PROGRESS ----------------
        const ALL_OFFERS = [
          { id:"bogo", label:"BOGO", icon:"🔥" }
        ]
        const ACTIVE_OFFERS = [...ALL_OFFERS]
        let progress = 0
        function getVisualProgress(raw){

          let prev = 0

          for(let i=0; i<ACTIVE_OFFERS.length; i++){

            const curr = ACTIVE_OFFERS[i].threshold

            if(raw < curr){

              const segmentSize = curr - prev
              const inside = raw - prev
              const ratio = inside / segmentSize

              return prev + (ratio * segmentSize)
            }

            prev = curr
          }

          return 100
        }

        // ---------------- UPDATE ----------------
        function update(){

          const visual = getVisualProgress(progress)
          $("#fill").css("width", visual + "%")

          let msg = ""

          for(let i=0; i<ACTIVE_OFFERS.length; i++){

            const offer = ACTIVE_OFFERS[i]
            const $el = $("#" + offer.id)

            $el.removeClass("active")

            if(progress >= offer.threshold){
              $el.addClass("active")
            } else {
              // $el.addClass("active")

              const diff = Math.ceil(offer.threshold - progress)
              msg = `You're ${diff}% away from ${offer.label}`
              break
            }
          }

          if(progress >= 100){
            msg = "All offers reached 🎯"
          }

          $("#msg").text(msg)
        }

        // ---------------- 🔥 GLOW (MANUAL ONLY) ----------------
        function activateOffer(offerId){

          // glow ONLY selected offer
          $(".step").removeClass("unlocked") // remove if single glow needed
          $("#" + offerId).addClass("unlocked")
        }

        // ---------------- 🎉 ANIMATION ----------------
        function fireConfetti(parentSelector) {
          const parent = document.querySelector(parentSelector);

          // create canvas dynamically
          const canvas = document.createElement('canvas');

          Object.assign(canvas.style, {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 9999
          });

          parent.appendChild(canvas);

          const myConfetti = confetti.create(canvas, {
            resize: true,
            useWorker: true
          });

          myConfetti({
            particleCount: 150,
            spread: 120,
            origin: { y: 0.3 }
          });

          // remove canvas after animation
          setTimeout(() => {
            canvas.remove();
          }, 2500);
        }
        function showOfferAnimation(label){

          let offers_html = `<div class="offer-show-animation-model">
                    <div class="offers-percentage-icon">
                      <img src="https://cdn.shopify.com/s/files/1/0089/0893/1152/files/offers-percentage-image.png?v=1776325790">
                    </div>
                    <h2>Woohoo!</h2>
                    <div class="offers-divider">
                      <span>★</span>
                    </div>

                    <p class="message">${label}</p>

                    <button class="awesome-btn">AWESOME</button>
                  </div>`
          
          $(".offer-show-animation").html(offers_html)
          fireConfetti("#cart-inner-div-dnd")
          // confetti({
          //   particleCount:120,
          //   spread:90
          // })

          setTimeout(function(){
            $('.offer-show-animation').html('')
          }, 2500)
        }

        // ---------------- ACTIONS ----------------
        function setProgress(val){
          progress = val
          update()
        }

        function setOffers(count){

          ACTIVE_OFFERS = ALL_OFFERS.slice(0, count)

          progress = 0

          init()
          update()
        }
         $(document).ready(function(){
          init()
          update()
        })
        if(excluded_prod_count > 0) {
            count = count - excluded_prod_count ;
        }

        if(count === 0){
        $('.diwali-pouch-display.active').html(``);
        $('.new-cart-upsell').hide();
        $('.offers-progressBr-temp').hide();
        $('.offers-progressBr').hide();
        $('.new-cart-upsell-temp').hide();
        $('.new-cart-upsell-temp-gloss-minis').hide();
        $('.new-cart-upsell-temp-gel-kajal').hide();
        $('.new-cart-upsell-temp-slickstick-mini').hide();
        $('.new-cart-upsell-temp-lip-glaze').hide();
        $('.new-cart-upsell-temp-mascara').hide();
        $('.new-cart-upsell-temp-primer').hide();
        $('.new-cart-upsell-temp-canvas-pouch').hide();
        $('.new-cart-upsell.non-aff').hide();
        $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
        $('.cart-recommedations').css('opacity','0');
        $('.new-cart-upsell-temp-eye-patch').hide();
        $('.new-cart-upsell.non-aff-foundation').hide();
        $('.new-cart-upsell .single-wish-product.cart').hide();
        $('.new-cart-upsell.non-aff-super-butter').hide();
        $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
        $('.new-cart-upsell.non-aff-stack').hide();
        $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
        $('.new-cart-upsell.non-aff-vegan-bag').hide();
        $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
        $('.free-skin-sample-products.day-cream-sample-product').hide();
        $('.free-skin-sample-products.night-cream-sample-product').hide();
        $('.free-skin-sample-products.cleanser-sample-product').hide();
        $('.new-cart-upsell.non-aff-lip-liner').hide();
        $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
        $('.new-cart-upsell.non-aff-lip-liner-half').hide();
        $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
        RemoveDiscountCodeFromCookie();
        isDiscountActive = false;
        setProgress(0);
        
      }
      else if(count >=1 && isExcludedProd === true ) {
          $('.diwali-pouch-display.active').html(``)
          $('.new-cart-upsell.non-aff').hide();
          $('.offers-progressBr-temp').hide();
          $('.offers-progressBr').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-slickstick-mini').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-primer').hide();
          $('.new-cart-upsell-temp-canvas-pouch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          $('.free-skin-sample-products.day-cream-sample-product').hide();
          $('.free-skin-sample-products.night-cream-sample-product').hide();
          $('.free-skin-sample-products.cleanser-sample-product').hide();
          $('.new-cart-upsell.non-aff-lip-liner').hide();
          $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
          setProgress(0);
        }
        else if(count === 1 && isExcludedProd === false && isBuy2at1299 === false) {
          $('.diwali-pouch-display.active').html(``);
          $('.add-more-product-text.banner__title.offer-message').html(`Add one more product & get the lower-MRP product FREE!`);
          $('.add-more-product-text.banner__title.next-offer-message').html(``);
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.new-cart-upsell-temp-primer').hide();
          $('.new-cart-upsell-temp-canvas-pouch').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner').hide();
          $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
          $('.free-skin-sample-products.day-cream-sample-product').hide();
          $('.free-skin-sample-products.night-cream-sample-product').hide();
          $('.free-skin-sample-products.cleanser-sample-product').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
          setProgress(50);
          wasTwoPaidNoClaim = true;
          fireClaimConfetti();
        }
        else if(count >= 2 && isExcludedProd === false && isBuy2at1299 === false) {
          $('.diwali-pouch-display.active').html(``);
          $('.add-more-product-text.banner__title.offer-message').html(`<strong>Offer Unlocked! </strong>Buy 1 product and get another product with lower MRP for free. Use your discount code at checkout.`);
          $('.add-more-product-text.banner__title.next-offer-message').html(``);
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.new-cart-upsell-temp-primer').hide();
          $('.new-cart-upsell-temp-canvas-pouch').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner').hide();
          $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
          $('.free-skin-sample-products.day-cream-sample-product').hide();
          $('.free-skin-sample-products.night-cream-sample-product').hide();
          $('.free-skin-sample-products.cleanser-sample-product').hide();
          RemoveDiscountCodeFromCookie();
          isDiscountActive = false;
          setProgress(100);
          activateOffer('bogo');
          showOfferAnimation('🔥 BOGO Offer Unlocked! Buy 1 and Get 1 FREE for a limited time only.');
        }
      
      }    
      else {
        
      // if(isliquid_lip === true){
       // if(count === 1 && selected_lip_count === 1 ){
       //    $('.new-cart-upsell').hide()
       //    $('.new-cart-upsell.ia').show()
       //    $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Buy 1 Get 1 free. Use code <strong>LIPB1G1</strong> </span>`)
       //    $('.new-cart-upsell-temp').hide()
       //     $('.new-cart-upsell-desk-offer').hide()
       //    affliliated_order = false
       //  }
       //   else if(count >= 2 && makeup_combo_handle === false && selected_lip_count === 1){
       //    $('.new-cart-upsell').hide()
       //    $('.new-cart-upsell.ia').show()
       //    $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Buy 1 Get 1 free. Use code <strong>LIPB1G1</strong> </span>`)
       //    $('.new-cart-upsell-temp').hide()
       //     $('.new-cart-upsell-desk-offer').hide()
       //    affliliated_order = false
       //  }
       //  else if(count >= 2 && makeup_combo_handle === false && selected_lip_count >= 2){
       //    $('.new-cart-upsell').hide()
       //    $('.new-cart-upsell.ia').hide()
       //    $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg">Get 1 product free. Use code <strong>LIPB1G1</strong></span>`)
       //    $('.new-cart-upsell-temp').hide()
       //     $('.new-cart-upsell-desk-offer').hide()
       //    affliliated_order = false
       //    }
        // }
      }
    }
        // Non Affilated code here
    else {

       // ---------------- INIT ----------------
        function init(){

          const $container = $("#steps")
          $container.html("")

          const total = ACTIVE_OFFERS.length
          const segment = 100 / total

          $.each(ACTIVE_OFFERS, function(index, offer){

            offer.threshold = segment * (index + 1)

            const $div = $(`
              <div class="step" id="${offer.id}" style="left:${index + 1 === total ?96 : offer.threshold}%">
                <div class="icon">${offer.icon}</div>
                <div class="label">${offer.label}</div>
              </div>
            `)

            $container.append($div)
          })
        }

        // ---------------- VISUAL PROGRESS ----------------
        const ALL_OFFERS = [
          { id:"bogo", label:"BOGO", icon:"🎁" }
        ]
        const ACTIVE_OFFERS = [...ALL_OFFERS]
        let progress = 0
        function getVisualProgress(raw){

          let prev = 0

          for(let i=0; i<ACTIVE_OFFERS.length; i++){

            const curr = ACTIVE_OFFERS[i].threshold

            if(raw < curr){

              const segmentSize = curr - prev
              const inside = raw - prev
              const ratio = inside / segmentSize

              return prev + (ratio * segmentSize)
            }

            prev = curr
          }

          return 100
        }

        // ---------------- UPDATE ----------------
        function update(){

          const visual = getVisualProgress(progress)
          $("#fill").css("width", visual + "%")

          let msg = ""

          for(let i=0; i<ACTIVE_OFFERS.length; i++){

            const offer = ACTIVE_OFFERS[i]
            const $el = $("#" + offer.id)

            $el.removeClass("active")

            if(progress >= offer.threshold){
              $el.addClass("active")
            } else {
              // $el.addClass("active")

              const diff = Math.ceil(offer.threshold - progress)
              msg = `You're ${diff}% away from ${offer.label}`
              break
            }
          }

          if(progress >= 100){
            msg = "All offers reached 🎯"
          }

          $("#msg").text(msg)
        }

        // ---------------- 🔥 GLOW (MANUAL ONLY) ----------------
        function activateOffer(offerId){

          // glow ONLY selected offer
          $(".step").removeClass("unlocked") // remove if single glow needed
          $("#" + offerId).addClass("unlocked")
        }

        // ---------------- 🎉 ANIMATION ----------------
        function fireConfetti(parentSelector) {
        const parent = document.querySelector(parentSelector);

        // create canvas dynamically
        const canvas = document.createElement('canvas');

        Object.assign(canvas.style, {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 9999
        });

        parent.appendChild(canvas);

        const myConfetti = confetti.create(canvas, {
          resize: true,
          useWorker: true
        });

        myConfetti({
          particleCount: 150,
          spread: 120,
          origin: { y: 0.3 }
        });

        // remove canvas after animation
        setTimeout(() => {
          canvas.remove();
        }, 2500);
      }
        function showOfferAnimation(label){

          let offers_html = `<div class="offer-show-animation-model">
                    <div class="offers-percentage-icon">
                      <img src="https://cdn.shopify.com/s/files/1/0089/0893/1152/files/offers-percentage-image.png?v=1776325790">
                    </div>
                    <h2>Woohoo!</h2>
                    <div class="offers-divider">
                      <span>★</span>
                    </div>

                    <p class="message">${label}</p>

                    <button class="awesome-btn">AWESOME</button>
                  </div>`
          
          $(".offer-show-animation").html(offers_html)
          fireConfetti("#cart-inner-div-dnd")
          // confetti({
          //   particleCount:120,
          //   spread:90
          // })

          setTimeout(function(){
            $('.offer-show-animation').html('')
          }, 2500)
        }

        // ---------------- ACTIONS ----------------
        function setProgress(val){
          progress = val
          update()
        }

        function setOffers(count){

          ACTIVE_OFFERS = ALL_OFFERS.slice(0, count)

          progress = 0

          init()
          update()
        }
         $(document).ready(function(){
          init()
          update()
        })
      if(excluded_prod_count > 0) {
          count = count - excluded_prod_count ;
      }
      // if(isFourPlayProd === true) {
      //   lip_count = lip_count - fourPlayProd_count;
      // }
      //  console.log("lip_count",lip_count);
      // console.log("count",count);

      // count = lip_count
      // if (isLip_liner === true){
      //   count = count - 1
      // }
      // if (isLip_Oil === true) {
      //   count = count - 1
      // }
      // count = lip_liner_count - lip_oil_count

      // Gamification bar: show by default on every recalculation (nothing else shows it again once hidden);
      // the empty-cart and excluded-product branches below still hide it.
      $('.offers-progressBr').show();

      if(count === 0){
        $('.diwali-pouch-display.active').html(``);
        $('.new-cart-upsell').hide();
        $('.offers-progressBr-temp').hide();
        $('.offers-progressBr').hide();
        $('.new-cart-upsell-temp').hide();
        $('.new-cart-upsell-temp-gloss-minis').hide();
        $('.new-cart-upsell-temp-gel-kajal').hide();
        $('.new-cart-upsell-temp-slickstick-mini').hide();
        $('.new-cart-upsell-temp-lip-glaze').hide();
        $('.new-cart-upsell-temp-mascara').hide();
        $('.new-cart-upsell-temp-primer').hide();
        $('.new-cart-upsell-temp-canvas-pouch').hide();
        $('.new-cart-upsell.non-aff').hide();
        $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
        $('.cart-recommedations').css('opacity','0');
        $('.new-cart-upsell-temp-eye-patch').hide();
        $('.new-cart-upsell.non-aff-foundation').hide();
        $('.new-cart-upsell .single-wish-product.cart').hide();
        $('.new-cart-upsell.non-aff-super-butter').hide();
        $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
        $('.new-cart-upsell.non-aff-stack').hide();
        $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
        $('.new-cart-upsell.non-aff-vegan-bag').hide();
        $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
        $('.free-skin-sample-products.day-cream-sample-product').hide();
        $('.free-skin-sample-products.night-cream-sample-product').hide();
        $('.free-skin-sample-products.cleanser-sample-product').hide();
        $('.new-cart-upsell.non-aff-lip-liner').hide();
        $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
        $('.new-cart-upsell.non-aff-lip-liner-half').hide();
        $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
        RemoveDiscountCodeFromCookie();
        isDiscountActive = false;
        setProgress(0);
        
      }
      else if(count >=1 && isExcludedProd === true ) {
          $('.diwali-pouch-display.active').html(``)
          $('.new-cart-upsell.non-aff').hide();
          $('.offers-progressBr-temp').hide();
          $('.offers-progressBr').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-slickstick-mini').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-primer').hide();
          $('.new-cart-upsell-temp-canvas-pouch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          $('.free-skin-sample-products.day-cream-sample-product').hide();
          $('.free-skin-sample-products.night-cream-sample-product').hide();
          $('.free-skin-sample-products.cleanser-sample-product').hide();
          $('.new-cart-upsell.non-aff-lip-liner').hide();
          $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
          setProgress(0);
        }
        else if(count === 1 && isExcludedProd === false && isBuy2at1299 === false) {
          $('.diwali-pouch-display.active').html(``);
          $('.add-more-product-text.banner__title.offer-message').html(`Add one more product & get the lower-MRP product FREE!`);
          $('.add-more-product-text.banner__title.next-offer-message').html(``);
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.new-cart-upsell-temp-primer').hide();
          $('.new-cart-upsell-temp-canvas-pouch').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner').hide();
          $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
          $('.free-skin-sample-products.day-cream-sample-product').hide();
          $('.free-skin-sample-products.night-cream-sample-product').hide();
          $('.free-skin-sample-products.cleanser-sample-product').hide();
          isDiscountActive = false;
          RemoveDiscountCodeFromCookie();
          setProgress(50);
          wasTwoPaidNoClaim = true;
          fireClaimConfetti();
        }
        else if(count >= 2 && isExcludedProd === false && isBuy2at1299 === false) {
          $('.diwali-pouch-display.active').html(``);
          $('.add-more-product-text.banner__title.offer-message').html(`<strong>BOGO Unlocked! Unlock more: Buy 2 Get 2 · Buy 3 Get 3</strong>`);
          $('.add-more-product-text.banner__title.next-offer-message').html(``);
          $('.new-cart-upsell.non-aff').hide();
          $('.new-cart-upsell.non-aff .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell-temp-gloss-minis').hide();
          $('.new-cart-upsell-temp-gel-kajal').hide();
          $('.new-cart-upsell-temp-lip-glaze').hide();
          $('.new-cart-upsell-temp-eye-patch').hide();
          $('.new-cart-upsell-temp-mascara').hide();
          $('.new-cart-upsell-temp-primer').hide();
          $('.new-cart-upsell-temp-canvas-pouch').hide();
          $('.cart-recommedations').css('opacity','0');
          $('.new-cart-upsell .single-wish-product.cart').hide();
          $('.new-cart-upsell.non-aff-foundation').hide();
          $('.new-cart-upsell.non-aff-foundation .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-super-butter').hide();
          $('.new-cart-upsell.non-aff-super-butter .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-slickstick').hide();
          $('.new-cart-upsell.non-aff-slickstick .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
          $('.new-cart-upsell.non-aff-stack .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-vegan-bag').hide();
          $('.new-cart-upsell.non-aff-vegan-bag .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner').hide();
          $('.new-cart-upsell.non-aff-lip-liner .single-wish-product.show-cart-upsell').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half').hide();
          $('.new-cart-upsell.non-aff-lip-liner-half .single-wish-product.show-cart-upsell').hide();
          $('.free-skin-sample-products.day-cream-sample-product').hide();
          $('.free-skin-sample-products.night-cream-sample-product').hide();
          $('.free-skin-sample-products.cleanser-sample-product').hide();
          RemoveDiscountCodeFromCookie();
          document.cookie = `discount_code=KIROBOGO`;
          isDiscountActive = true;
          var discount_code_object = {
            "discount_code":"KIROBOGO",
            "discount_message":``,
            "discount_applied_message":``
            }
          discountOnCart_Array.push(discount_code_object);
          setProgress(100);
          activateOffer('bogo');
          showOfferAnimation('🔥 BOGO Offer Unlocked! Buy 1 and Get 1 FREE for a limited time only.');
        }
      
       else {
        $('.diwali-pouch-display.active').html(`<span class="diwali-cart-msg"></span>`)
          $('.new-cart-upsell').hide()
          $('.new-cart-upsell-temp').hide();
          $('.new-cart-upsell.non-aff-stack').hide();
         $('.cart-recommedations').css('opacity','0');
         $('.new-cart-upsell-temp-gel-kajal').hide();
         $('.new-cart-upsell-temp-slickstick-mini').hide();
         RemoveDiscountCodeFromCookie();
         
      }
    }
  // clearSetTimoutFunction3 = setTimeout(function(){
  //   if(data.item_count === 0) {
  //     //console.log("before settimeout cart count")
     
  //     // console.log("after settimeout cart count")
  //     //  closeCartIfEmptyForProducts()
  //   }
  //   else {
  //      clearTimeout(clearSetTimoutFunction3)
  //   }
  //   },1500)
        // console.log("isDiscountActive",isDiscountActive)
        // console.log("discount_code_object",discount_code_object)
        if (isDiscountActive === true) {
          $('.coupon-input').val(`${discount_code_object.discount_code}`);
          calculateDiscount({
            "cart_data": data,
            "discount_code": discount_code_object.discount_code
          })
        }
        else{
          $('.coupon-apply-btn').text(`Apply`);
          $('.coupon-input').val('');
        }


    //  var getDiscountData = JSON.parse(window.sessionStorage.getItem('discount_function'))
    //     if(getDiscountData){
    //       if(getDiscountData.discount_code_data.discount_clicked === true ) {
    //         $.ajax({
    //           cache: false,
    //           async: false,
    //           url: `/cart.js`,
    //           dataType: "json",
    //           type: "GET",
    //           success: function(data) {
    //             var discount_code_details = {
    //               "cart_data":data,
    //               "discount_code":getDiscountData.discount_code_data.discount_code
    //             };
    //            calculateDiscount(discount_code_details)
    //           }
    //         })
    //       }
    //     }
    //     else {
    //       showAvailableOffers(discountOnCart_Array);
    //     }
    // // console.log("discountOnCart_Array",discountOnCart_Array)
    // discountOnCart_Array.forEach((element)=>{
    //   discountOnCartArrayDublicate.push(element)
    // })

    // console.log("display_pouch_elegibity ends",new Date())

  }

  // code for men-skin  SKIN MEN in PDP
$(document).ready(function () {

    var currentPage = window.location.pathname;
    var pathParts = window.location.pathname.split('/');

    var productHandle = '';

    if (pathParts.length >= 3 && pathParts[1] === 'products') {
        productHandle = pathParts[2];
    }

    var storageKey = 'men_skin_flow';
    var menSkinPages = [
        '/pages/skin-men',
        '/collections/skin-men',
        '/pages/kiro-skin-men-know-more'
    ];
    function isMenSkinPage(page) {
        return menSkinPages.indexOf(page) !== -1;
    }
    var menSkinFlow = sessionStorage.getItem(storageKey);
    if (menSkinFlow) {
        try {
            menSkinFlow = JSON.parse(menSkinFlow);
        } catch (e) {
            menSkinFlow = null;
            sessionStorage.removeItem(storageKey);
        }
    }
    var referrerPage = '';
    if (document.referrer) {
        try {
            referrerPage = new URL(document.referrer).pathname;
        } catch (e) {
            referrerPage = '';
        }
    }
    if (isMenSkinPage(currentPage)) {
        menSkinFlow = {
            men_skin: true,
            current_page: currentPage,
            previous_page: currentPage
        };
        sessionStorage.setItem(
            storageKey,
            JSON.stringify(menSkinFlow)
        );
        return;
    }
    if (currentPage.indexOf('/products/') === 0 && isMenSkinPage(referrerPage)) {
        menSkinFlow = {
            men_skin: true,
            current_page: currentPage,
            previous_page: referrerPage
        };
        sessionStorage.setItem(
            storageKey,
            JSON.stringify(menSkinFlow)
        );
    }
    var latestFlow = sessionStorage.getItem(storageKey);
    if (latestFlow) {
        try {
            menSkinFlow = JSON.parse(latestFlow);
        } catch (e) {
            menSkinFlow = null;
        }
    }
    if (!menSkinFlow || menSkinFlow.men_skin !== true) {
        return;
    }
    if (menSkinFlow.current_page === currentPage) {

    }

    else {
        var oldCurrentPage = menSkinFlow.current_page;
        menSkinFlow = {
            men_skin: true,
            current_page: currentPage,
            previous_page: oldCurrentPage
        };
        sessionStorage.setItem(
            storageKey,
            JSON.stringify(menSkinFlow)
        );
    }

    if (currentPage.indexOf('/products/') === 0 && isMenSkinPage(menSkinFlow.previous_page)) {
        $('.skin-tag-logo').attr('href','/pages/skin-men');
        $('.skin-home-breadcrumb').attr('href','/pages/skin-men');
        $('.skin-collection-breadcrumb').attr('href','/collections/skin-men');
        $('.claims-photo img').attr('src','https://cdn.shopify.com/s/files/1/0089/0893/1152/files/Every_promise_Opt-2_men.webp');
        $('.skin-collection-breadcrumb').text('SKIN MEN');
        $('.pdp-section.how-to-use').hide();
        fetch(`/products/${productHandle}?sections=men-pdp-section-rendering`)
        .then(function (response) {
            return response.json();
        }).then(function (data) {
                var html =  data["men-pdp-section-rendering"];
                if (!html) {
                    console.log(
                        'Section HTML not found'
                    );
                    return;
                }
                var $newSlider =  $(html).find('.slider-container');
                var $newSlider_desktop =  $(html).find('.slider-container-desktop');
                var $slider =  $('#pdpSlider');
                var $slider_desktop =  $('#pdpSliderNav');
                if (!$newSlider.length) {
                    return;
                }
                if ($slider.hasClass('slick-initialized')) {
                  $slider.slick('unslick');
                }
                if ($slider_desktop.hasClass('slick-initialized')) {
                  $slider_desktop.slick('unslick');
                }
                $slider.html($newSlider.html());
                $slider_desktop.html($newSlider_desktop.html());
                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    swipe: true,
                    adaptiveHeight: false,
                    asNavFor: '#pdpSliderNav',
                    prevArrow:
                        '<button type="button" class="slick-prev" aria-label="Previous image">' +
                            '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
                                '<path d="M15 18l-6-6 6-6"></path>' +
                            '</svg>' +
                        '</button>',
                    nextArrow:
                        '<button type="button" class="slick-next" aria-label="Next image">' +
                            '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
                                '<path d="M9 18l6-6 6-6"></path>' +
                            '</svg>' +
                        '</button>'

                });
                $slider_desktop.slick({
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  vertical: true,
                  verticalSwiping: true,
                  asNavFor: '#pdpSlider',
                  focusOnSelect: true,
                  arrows: true,
                  infinite: false,
                  prevArrow: '<button type="button" class="slick-prev" aria-label="Previous thumbnails"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M15 18l-6-6 6-6"></path></svg></button>',
                  nextArrow: '<button type="button" class="slick-next" aria-label="Next thumbnails"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M9 18l6-6-6-6"></path></svg></button>'
                });
            }).catch(function (error) {

                console.log(
                    'Section rendering error:',
                    error
                );

            });

    } else {

        console.log(
            'Section Rendering NOT required'
        );

    }

});





   function re_render_cart_for_coupan_change(cart,response) {
    const parsedHTML = $('<div>').html(response['cart-rendering']);
    const order_summary = parsedHTML.find("#order-summary").html();
    const savings_banner = parsedHTML.find("#savings-banner").html();
    const total_section = parsedHTML.find("#total-section").html();
    $('.order-summary').html(order_summary);
    $('.savings-banner').html(savings_banner);
    $('.total-section').html(total_section)
  }
  let couponTimer;

  $('.coupon-form').on('input', '.coupon-input', function () {
    const $input = $(this);
    const $button = $input.siblings('.coupon-apply-btn');
    $button.text('Apply');
    clearTimeout(couponTimer);
    // Only run when the input is empty
    if ($input.val().trim() === '') {
        couponTimer = setTimeout(function () {
            lockCart();
            $.ajax({
                cache: false,
                async: false,
                url: `/cart.js`,
                dataType: "json",
                type: "GET",
                success: function(data) {
                    $.ajax({
                        type: "GET",
                        url: "/?sections=cart-rendering",
                        dataType: "json",
                        success: function(response) {
                            re_render_cart_for_coupan_change(data, response);
                            unlockCart();
                        },
                        error: function(error) {
                            console.log("error", error);
                            unlockCart();
                        }
                    });
                },
                error: function(error) {
                    console.log("error", error);
                    unlockCart();
                }
            });
        }, 500);
    }
  });
  function showAvailableOffers(discountOnCart_Array) {
    var getDiscountData = JSON.parse(window.sessionStorage.getItem('discount_function'))
    if(isDiscountActive === true) {
      if(discountOnCart_Array.length >= 1) {
        var objectToPush = '';
        discountOnCart_Array.forEach((element)=>{
          if(getDiscountData){
            if(getDiscountData.discount_code_data.discount_clicked === true ) {
              if(getDiscountData.discount_code_data.discount_code === element.discount_code) {
                $('.coupon-apply-btn').text(`Applied`);
                $('.coupon-input').val(`${element.discount_code}`);
                objectToPush +=`<div class="discount-message">
                                <span>${element.discount_applied_message}</span>
                              </div>
                              <div>
                              <button class="discount-applied-btn" style="background-color:rgb(63,50,50,0.8);outline:none;border:none;padding:0px 5px;font-size:14px;color:#fff;position:absolute;top:10px;">Applied</button>
                              </div>`
                $('.add-more-product-text.banner__title').html(`${element.discount_applied_message}`)
              }
              else {
                $('.coupon-apply-btn').text(`Apply`);
                $('.coupon-input').val(`${element.discount_code}`);
                objectToPush += `<div class="discount-message">
                                <span>${element.discount_message}</span>
                              </div>
                              <div class="discount-apply-btn apply-discount-code-btn" discountValue="${element.discount_code}">
                                <button>Apply</button>
                              </div>`
                $('.add-more-product-text.banner__title').html(`${element.discount_message}`)
              }
            }
          }
          else {
            $('.coupon-apply-btn').text(`Apply`);
            $('.coupon-input').val(`${element.discount_code}`);
            objectToPush += `<div class="discount-message">
                                <span>${element.discount_message}</span>
                              </div>
                              <div class="discount-apply-btn apply-discount-code-btn" discountValue="${element.discount_code}">
                                <button>Apply</button>
                              </div>`
            $('.add-more-product-text.banner__title').html(`${element.discount_message}`)
          }             
        })
        $('.show-all-the-discount-container').html(objectToPush)
        $('.show-all-the-discount-container').show()
      }
      else {
        $('.coupon-apply-btn').text(`Apply`);
        $('.coupon-input').val('');
        $('.show-all-the-discount-container').hide()
      }
    }
    else {
      $('.coupon-apply-btn').text(`Apply`);
      $('.coupon-input').val('');
      $('.show-all-the-discount-container').hide()
    }
  }

  function calculateDiscount(discount_code) {
     $('.coupon-apply-btn').text(`Calculating...`);
     $('.original-price').text('');
     $('.original-price').addClass("loader_on_cart");
     $('.total-price-to-pay').text('');
     $('.total-price-to-pay').addClass("loader_on_cart");
     // Same loading dots on the Estimated Total box (.total-section). Its content is kept so it can be put back
     // when the response doesn't redraw it (price unchanged, offer rejected or request failed).
     var totalSectionBefore = $('.total-section').html();
     $('.total-section .prices').html(`<span class="total-section-loader loader_on_cart"></span>`);

     $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://o2hqdmkho1.execute-api.us-east-2.amazonaws.com/shopify_production/discount-validation`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers","Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "7wHs2PGuLR8sXyRcIhbtbPrTVmxogDi9I840KoZ4");
        },
        data: JSON.stringify(discount_code),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      }).always(function() {
        // Runs first (before done/fail): restore the Estimated Total; a successful new price then overwrites it in done()
        if ($('.total-section .total-section-loader').length) $('.total-section').html(totalSectionBefore);
      }).done(function(response) {
        console.log("Successfully posted data",response);
        console.log("response.statusCode",response.statusCode)
        //console.log("response",response)
        if(response.statusCode === 200 ){
          var discount_response = JSON.parse(response.body)
          var old_cart_price = discount_response.old_cart_price / 100;
          var discount_obj_localstorage = {
            "discount_code_data": {
              "discounted_price":discount_response.new_cart_price,
              "discount_code":discount_response.discount_code,
              "discount_clicked":true
            }
          }
           var get_mrp_total = 0, isMRPSucess = false;
            $.ajax({
            cache: false,
            async: false,
            url: `/cart.js`,
            dataType: "json",
            type: "GET",
            success: function(data) {
              for(var i=0;i<data.items.length;i++){
                $.ajax({
                  cache: false,
                  async: false,
                  url: `/products/${data.items[i].handle}.js`,
                  dataType: "json",
                  type: "GET",
                  success: function(product_data) {
                    var compare_at_price = product_data.compare_at_price / 100
                    get_mrp_total += compare_at_price * data.items[i].quantity
                  }
                })
              }
            }
          })
          if (old_cart_price !== discount_response.new_cart_price) {
            let total_saving = get_mrp_total - discount_response.new_cart_price;
            let total_saving_percentage = ((get_mrp_total-discount_response.new_cart_price)/get_mrp_total)*100
            let discount_code_off = old_cart_price - discount_response.new_cart_price;
            $('.original-price').removeClass("loader_on_cart");
            $('.original-price').text(`₹${get_mrp_total}`);
            $('.total-price-to-pay').text('');
            $('.total-price-to-pay').addClass("loader_on_cart");

            $('.savings-banner').html(`<p><b>₹${total_saving}</b> saved so far 💋 You've Unlocked Free Shipping!</p>`);
            $('.total-section').html(`<span class="total-label">Estimated Total</span><div class="prices">
              <span class="old-price slash-price">₹${get_mrp_total}</span>
              <span class="new-price">₹${discount_response.new_cart_price}</span>
              <span class="discount">${Math.floor(total_saving_percentage)}% off</span>
              </div>`);
            var $div = $('.order-summary-rows-container');
            var $child = $div.find('.summary-row.positive.discount');
            if ($child.length) {
                // Child exists → update HTML
                $child.html(`<span>Discount Code (${discount_response.discount_code})</span><span class="green">-₹${discount_code_off}</span>`);
            } else {
                // Child doesn't exist → create it
                $div.append(`<div class="summary-row positive discount"><span>Discount (${discount_response.discount_code})</span><span class="green">-₹${total_saving}</span></div>`);
            }
            $('.summary-row.total').html(`<span class="label-total">Total (incl. of all taxes)</span><span class="total-price-to-pay">₹${discount_response.new_cart_price}</span>`)
          }
          // $('.subtotal').html(`<span class="subtotal">${(old_cart_price !== discount_response.new_cart_price)? `<s>&#8377; ${get_mrp_total}</s>`:``} &#8377; ${discount_response.new_cart_price} </span>`)
          window.sessionStorage.setItem('discount_function', JSON.stringify(discount_obj_localstorage))
          $(".form-checkout").attr('action',`https://kirobeauty.com/discount/${discount_response.discount_code}?redirect=/checkout`)
          $(".checkout.cart-checkout").attr('action',`https://kirobeauty.com/discount/${discount_response.discount_code}?redirect=/checkout`)
          // showAvailableOffers(discountOnCartArrayDublicate)
          $('.coupon-apply-btn').text(`Applied`);
          $('.coupon-input').val(discount_response.discount_code);
          
          
          document.cookie = `discount_code=${discount_code.discount_code}`
        }
        else if(response.statusCode === 301) {
            var getDiscountData = JSON.parse(window.sessionStorage.getItem('discount_function'))
            if(getDiscountData) {
            if(getDiscountData.discount_code_data.discount_clicked === true ) {
              alert(`Your cart is empty`);
              RemoveCartDetailsFromSession();
              $('.coupon-apply-btn').text(`Apply`);
              $('.coupon-input').val('');
           }  
          }
        }
        else if(response.statusCode === 302) {
          var getDiscountData = JSON.parse(window.sessionStorage.getItem('discount_function'))
            if(getDiscountData) {
            if(getDiscountData.discount_code_data.discount_clicked === true) {
                  $('.coupon-apply-btn').text(`Apply`);
                  $('.coupon-input').val('');
                 if(getDiscountData.discount_code_data.discount_code === "FREEGLOSSMINI") {
                   alert(`Please add to bag glossifinity minis to avail the offer.`);
                   RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREENEWKAJAL") {
                    alert(`Please add minimum 1 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREEMINI") {
                    alert(`Please add minimum 1 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREELIPLINER") {
                    alert(`Please add minimum 1 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREEEYESHADOW") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREELIPOIL") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "KIROBOGO") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "BOGOGIFT") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "KiroFace1") {
                    alert(`Please add minimum 1 face products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "KiroFace2") {
                    alert(`Please add minimum 2 face products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "KIROB2G1") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREEBAG") {
                    alert(`Please add minimum 2 products and vegan leather bag to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FLAT25") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FLAT30") {
                    alert(`Please add minimum 3 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "KIROB1G1TEST") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "FREELIPOIL") {
                    alert(`Please add minimum 2 lip products and 1 Shape & Define Lip Liner and 1 pH-Play Lip & Cheek Oil - Cherry Nectar to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  else if(getDiscountData.discount_code_data.discount_code === "KIROBOGO") {
                    alert(`Please add minimum 2 products to cart to avail the offer.`);
                    RemoveCartDetailsFromSession() 
                  }
                  
           }  
          }
          $('.coupon-apply-btn').text(`Apply`);
          $('.coupon-input').val('');
          display_subtotal()
            // alert("Cart items are invalid. Minimum product quanity doesn't match.");
            // RemoveCartDetailsFromSession()
        }
        else {
          $('.coupon-apply-btn').text(`Apply`);
          $('.coupon-input').val('');
          RemoveCartDetailsFromSession()
          display_subtotal()
        }

        function RemoveCartDetailsFromSession() {
          var getDiscountData = JSON.parse(window.sessionStorage.getItem('discount_function'))
          if(getDiscountData) {
             if(getDiscountData.discount_code_data.discount_clicked === true ) {
             window.sessionStorage.removeItem('discount_function')
            //  showAvailableOffers(discountOnCartArrayDublicate)
              document.cookie = `discount_code=${discount_code.discount_code};max-age=0`
           }  
          }
        }
      })
      .fail(function(error){
      console.log("Failure : ", error);
      if(onComplete) onComplete(false)
      })
  }

   window.applyCouponDiscount = function(discountCode) {
    console.log("discountCode",discountCode)
    $.ajax({
      cache: false,
      async: false,
      url: `/cart.js`,
      dataType: "json",
      type: "GET",
      success: function(data) {
        calculateDiscount({
          "cart_data": data,
          "discount_code": discountCode
        })
        // , function(applied) {
        //   $('.coupon-form .coupon-apply-btn')
        //     .prop('disabled', false)
        //     .text(applied ? 'Applied' : 'Apply');
        // })
      }
    })
  }
  $(document).on('click','.apply-discount-code-btn',function(){
    var discount_code = $(this).attr('discountValue')
    // console.log("discount_code",discount_code)
    // console.log("$(this)",$(this))
    $(this).html(`<button style="padding:0px 3px;font-size:12px;background-color:#fff;border:none;color:#000;">Applying...</button>`)
    $.ajax({
      cache: false,
      async: false,
      url: `/cart.js`,
      dataType: "json",
      type: "GET",
      success: function(data) {
        var discount_code_details = {
          "cart_data":data,
          "discount_code":discount_code
        };
       calculateDiscount(discount_code_details)
      }
    })
  })
  
  
  function RemoveDiscountCodeFromCookie() {
   let temporryCookie = document.cookie;
    if(temporryCookie.includes('discount_code=FREEGLOSSMINI')) {
         document.cookie = `discount_code=FREEGLOSSMINI;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=FREEDN')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=FLAT25')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=BULLETBOGO')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=FREENEWKAJAL')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=FREEMINI')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=FREEEYESHADOW')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=KIROBOGO')) {
      document.cookie = `discount_code=; Max-Age=0; path=/` 
    }
    else if(temporryCookie.includes('discount_code=FREELIPLINER')) {
      document.cookie = `discount_code=FREELIPLINER;max-age=0` 
    }
    // else if(temporryCookie.includes('discount_code=FREEEYESHADOW')) {
    //   document.cookie = `discount_code=FREEEYESHADOW;max-age=0` 
    // }
    else if(temporryCookie.includes('discount_code=FREELIPOIL')) {
      document.cookie = `discount_code=FREELIPOIL;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=BOGOGIFT')) {
      document.cookie = `discount_code=BOGOGIFT;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=KiroFace1')) {
      document.cookie = `discount_code=KiroFace1;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=KiroFace2')) {
      document.cookie = `discount_code=KiroFace2;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=KIROB2G1')) {
      document.cookie = `discount_code=KIROB2G1;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=FREEBAG')) {
      document.cookie = `discount_code=FREEBAG;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=KIROB1G1TEST')) {
      document.cookie = `discount_code=KIROB1G1TEST;max-age=0` 
    }
    else if(temporryCookie.includes('discount_code=FLAT30')) {
      document.cookie = `discount_code=FLAT30;max-age=0` 
    }


    
  }
  RemoveDiscountCodeFromCookie();
  // function to animate cart-upsell-message.
    let cart_upsell_message_new = "Don't forget to add to bag. Discount will be applied at checkout.";
    let showAnimationOrNot = false;
    function showAnimationOnCartUpsellSelectProdMessage() {
      console.log("showAnimationOnCartUpsellSelectProdMessage is called")
      let cart_upsell_message = document.querySelectorAll('.cart-upsell-select-prod-message');
      cart_upsell_message.forEach(container => {
        displayCharacter(container); // Start displaying for each container
      });
    }

    function displayCharacter(cart_upsell_message_container) {
      cart_upsell_message_container.textContent = '';
        let cart_upsell_message_length = 0;
        function showCharacterAnimation() {
          if(showAnimationOrNot) {
             if(cart_upsell_message_length < cart_upsell_message_new.length) {
                cart_upsell_message_container.textContent += cart_upsell_message_new[cart_upsell_message_length];
                cart_upsell_message_length++;
                setTimeout(showCharacterAnimation, 40); // Adjust the delay here for speed
             }
             else {
              setTimeout(()=>{
               displayCharacter(cart_upsell_message_container)
              }, 5000);
            } 
          }
        }
        showAnimationOrNot = true;
        showCharacterAnimation();
    }
    showAnimationOnCartUpsellSelectProdMessage();
    // function stopAnimationOnCartUpsellSelectProdMessage() {
    //   showAnimationOrNot = false;
    //   let stop_cart_upsell_message = document.querySelectorAll('.cart-upsell-select-prod-message');
    //   stop_cart_upsell_message.forEach(container => {
    //     container.textContent = ''; // Clear all messages when stopped
    //   });
    // }
  
  
  if(sessionStorage.kvsl){
    var cart = JSON.parse(sessionStorage.kvsl);
    // Guarded: an error here used to stop the rest of this file, so +/-, Remove and Add to Bag never got their handlers
    try { display_pouch_elegibity(cart) } catch (err) { console.error('[Kiro cart] display_pouch_elegibity failed on load', err) }
  }
  function postSkintoneData(skintone_object) {
    console.log('function is called')
     $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://0kffyf5pj8.execute-api.us-east-2.amazonaws.com/shopify_production/kiro_click_on_skintone_selection_data`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers","Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "bdiXl4F7KQ3u086rrfmsIadT9gBF9kyG90fDH3V6");
        },
        data: JSON.stringify(skintone_object),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      })
      .done(function(response) {
        //response send
      })
      .fail(function(error){
      console.log("Failure : ", error);
      })
  }

  
  
  $(document).on('click','.checkmark.skintone-selection-checkmark',function(event) {
     var element = event.target;
    var selected_tone_siblings = $(this).siblings()[1];
    var selected_skintone = selected_tone_siblings.attributes.value.nodeValue
    var previous_selected_skintone = window.localStorage.skintone
    var skintToneObject = {
      "skintone":"",
      "date":"",
      "count":"",
    }
    if(previous_selected_skintone) {
      // customer has already selected skintone
       var previous_selected_skintone_value = JSON.parse(previous_selected_skintone)
      const skintone_click_date = new Date();
      const new_skintone_date = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
      
      const date_to_post = `${
          new_skintone_date(skintone_click_date.getDate())}-${
          new_skintone_date(skintone_click_date.getMonth()+1)}-${
          skintone_click_date.getFullYear()} ${
          new_skintone_date(skintone_click_date.getHours())}:${
          new_skintone_date(skintone_click_date.getMinutes())}:${
          new_skintone_date(skintone_click_date.getSeconds())}`
      const current_location_for_skintone = window.location.href.split('https://kirobeauty.com')[1]
       if(previous_selected_skintone_value[0] === selected_skintone) {
        // customer has unselected the skintone 
       }
      else {
        // customer has selected the new skintone
          skintToneObject = {
              "skintone":selected_skintone,
              "date":date_to_post,
              "count":1,
              "location":current_location_for_skintone
            }
          postSkintoneData(skintToneObject)
        }
    }
    else {
      // customer is selecting skintone first time
       skintToneObject = {
            "skintone":selected_skintone,
            "date":date_to_post,
            "count":1,
            "location":current_location_for_skintone
        }
      postSkintoneData(skintToneObject) 
     }
  })

  
  //  $(document).on('click','.redirection-to-dynamic-bundle-zero',function(){
  //    $('.cart-inner.wishcart-inner-div').html(``)
  //   $.ajax({
  //     url: `/cart/clear.js`,
  //     dataType: "json",
  //     type: "POST",
  //     success: function(data) {
  //       // window.sessionStorage.setItem('kvsl', JSON.stringify(data))
  //       setTimeout(function(){display_subtotal()}, 50)
  //       display_cart_slider_info()
  //       location.href='https://kirobeauty.com/collections/buy-2-at-1299';
  //     }
  //   })
  //     display_cart_slider_info();
  //     $('.cart-inner.wishcart-inner-div').html(``);
  // })
 
  // --------------------------------------------------- End Diwali Pouch Eligibity ------------------------------------------- //

 // $(document).on('click', '.non-aff',function(){
 //   $(".show-non-aff-msg").show()
 //    $(this).text("ADDED")
 //  //       $(this).removeClass('action')
 // })

  function display_subtotal(){
    $.ajax({
      cache: false,
      async: false,
      url: `/cart.js`,
      dataType: "json",
      type: "GET",
      success: function(data) {
        var get_mrp_total = 0, isMRPSucess = false;
        for(var i=0;i<data.items.length;i++){
          $.ajax({
            cache: false,
            async: false,
            url: `/products/${data.items[i].handle}.js`,
            dataType: "json",
            type: "GET",
            success: function(product_data) {
              var compare_at_price = product_data.compare_at_price / 100
              get_mrp_total += compare_at_price * data.items[i].quantity
            }
          })
        }
        setTimeout(function(){
          if(get_mrp_total > data.items_subtotal_price / 100){
            isMRPSucess = true
          }
          // console.log("get_mrp_total", get_mrp_total)
          // console.log("isMRPSucess", isMRPSucess)
          // console.log("(isMRPSucess && (get_mrp_total !== data.items_subtotal_price))", (isMRPSucess && (get_mrp_total !== data.items_subtotal_price / 100)))
          $(".cart-count").text(data.item_count !== 0? data.item_count:'');
          $('.subtotal').html(`<span class="subtotal">${(isMRPSucess && (get_mrp_total !== data.items_subtotal_price))? `<s>&#8377; ${get_mrp_total}</s>`:``} &#8377; ${data.items_subtotal_price / 100} </span>`);
          if(data.item_count === 0){
            $(".cart-empty").show();
            $(".progressBr").hide();
            $(".checkout-form").hide();
            $(".cart-actions").hide();
            $(".offers-progressBr").hide();
          }
          display_pouch_elegibity(data); // Pouch
        }, 100)
      }
    })
  };

  function remove_cart(vid){
    // remove and update cart_count
    var ie = JSON.parse(window.sessionStorage.getItem('kvsl'));
    var index;

    index = ie.items.findIndex(function(element, index){
      return (element.id === parseInt(vid));
      
    });
    
    ie.items.splice(index,1);
    
    window.sessionStorage.setItem('kvsl', JSON.stringify(ie));
    display_product_added();

    setTimeout(function(){display_cart_slider_info()},200);
    var $wishCart_inner = $(document).find('.wishcart-inner-div')
    $wishCart_inner.each(function(){$(this).children().eq(index).remove();})
    //       $wishCart_inner.eq(index).remove();
    if($wishCart_inner.length === 1) { $('.cart-upsell').html(''); }

  }

  window.showCartLively = function() {
     $.ajax({
      cache: false,
      url: `/cart.js`,
      dataType: "json",
      type: "GET",
      success: function(data) {
        $.ajax({
          type:"GET",
          url:"/?sections=cart-rendering",
          dataType: 'json',
          success: function(response) {
            re_render_cart(data,response)
            unlockCart();
          },
          error: function(error) {
            console.log("error",error);
          }
        });
      }
    })
  }
  
  $(document).on('click','#pop-up-active',function(){
    display_product_added()
  });


  function bundleajaxRun(url, payload){
    //         console.log("payload", payload)
    var result;
    if(payload){
      $.ajax({
        cache: false,
        url: url,
        dataType: "json",
        type: "POST",
        data: payload,
        success: function(response){
          //                 console.log("cart response", response)
        }
      })
    } else {
      $.ajax({
        cache: false,
        async: false,
        url: url,
        dataType: "json",
        type: "GET",
        success: function(response){
          //                   console.log("product response", response)
          result = response
        }
      })
    }

    return result;

  }



  function add_bundle_to_cart(prod_id,var_id, type, handle, quantity, avail_qty, $selector, $bundleselection){

    var product_arr = []
    $bundleselection.children('.selection').each(function(){
      product_arr.push(
        {
          "id": $(this).children().attr("vid"),
          "handle": $(this).children().attr("handle"),
          "name": $(this).children().text()
        }
      )}
                                                )
        // console.log("product_arr", product_arr)

    var barcode_id = product_arr.reduce(
      function(accu_str, element, index){
        if(element.handle === 'Pouch'){
          accu_str += "," + element.id;
        }
        else{
          var prod_json = bundleajaxRun(`/products/${element.handle}.js`)
          // console.log("prod_json fom bundle", prod_json);
          var getBarcode = prod_json.variants.reduce(
            function(accu, var_ele, idx ){
              if(var_ele.id === parseInt(element.id) && 
                 var_ele.available === true){
                //                  console.log("var_ele", var_ele)
                accu += var_ele.sku
              }
              return accu;
            },'')
          accu_str += "," + getBarcode;
        }
        return accu_str;
      },"")
    //      console.log("barcode_id", barcode_id);
    var properties_obj = product_arr.reduce(
      function(accu_obj, element, index){
        accu_obj[`Product${index + 1}`] = element.name;
        return accu_obj
      },{})
    properties_obj["_barcode"] = barcode_id
    properties_obj["_is_Dynamic_bundle"] = true;
    //      console.log("properties_obj", properties_obj);

    let Bundle_Data = {
      'items':[
        {
          'id': parseInt(var_id),
          'quantity': quantity,
          'properties':properties_obj
        }]
    }
    //      console.log("Bundle_Data", Bundle_Data)

    //     return {}

    var get_cart = JSON.parse(window.sessionStorage.getItem("kvsl"))

    var if_variable = get_cart.items.filter(item =>((item.id === parseInt(var_id)) && (item.properties["_barcode"]===properties_obj["_barcode"])));

    //      console.log("if_variable", if_variable)

    if(if_variable.length === 0){
      //        console.log("Here first")
      $.ajax({
        cache: false,
        url: `/cart/add.js`,
        dataType: "json",
        type: "POST",
        data: Bundle_Data,
        success: function(data) {

           $.ajax({
            cache: false,
            async: false,
            type:"GET",
            url:"/cart.js",
            dataType: 'json',
            success: function(cart) {
              $.ajax({
                type:"GET",
                url:"/?sections=cart-rendering",
                dataType: 'json',
                success: function(response) {
                  re_render_cart(cart,response)
                  //  const parsedHTML = $('<div>').html(response['cart-rendering']);
                  // // Extract only #cart-inner
                  // const cartInner = parsedHTML.find('#cart-inner').html();
                  // const original_price = parsedHTML.find("#subtotal").html();
                  // const cart_count = parsedHTML.find("#total_items").html();
                  // // Replace only inside your container
                  // $(".cart-count").text(data_for_quantity_change.item_count !== 0? data_for_quantity_change.item_count:'');
                  // $('.subtotal').html(`<span class="subtotal">${parseInt(original_price) !== parseInt(data_for_quantity_change.items_subtotal_price / 100) ? `<s>&#8377; ${original_price}</s>`:``} &#8377; ${data_for_quantity_change.items_subtotal_price / 100} </span>`);
                  // $('#cart-inner').html(cartInner);
                  unlockCart();
                },
                error: function(error) {
                  console.log("error",error);
                }
              });
            },
            error: function(error) {
              console.log("error",error);
            }
          });

        }
      });

    } else if(if_variable.length !== 0) {
      //        console.log("Here second")
      var get_cart = JSON.parse(window.sessionStorage.getItem("kvsl"))
      var variable = get_cart.items.find(item =>((item.id === parseInt(var_id)) && (item.properties["_barcode"]===properties_obj["_barcode"])));

      var check_quantity = (quantity === undefined ? 1: parseInt(quantity)) + parseInt(variable.quantity)

      var idx = get_cart.items.findIndex(function(item, index){
        return item.id === parseInt(var_id);
      });
      get_cart.items[idx].quantity = check_quantity;
      var $wishCart_inner = $(document).find('.wishcart-inner-div').children()

      $wishCart_inner.eq(idx).find('input').val(check_quantity < avail_qty? check_quantity: avail_qty);
      var variableIndex = get_cart.items.findIndex(item =>((item.id === parseInt(var_id)) && (item.properties["_barcode"]===properties_obj["_barcode"])));
      var add_quantity = {
        'id': parseInt(var_id),
        'line':variableIndex + 1
      };
      add_quantity.quantity = check_quantity > avail_qty ? avail_qty:check_quantity;
      if(add_quantity.quantity > 5){
        return {}
      }

      $.ajax({
        cache: false,
        url: `/cart/change.js`,
        dataType: "json",
        type: "POST",
        data: add_quantity,
        success: function(data) {
          setTimeout(function(){display_subtotal()}, 50)

          window.sessionStorage.setItem("kvsl", JSON.stringify(data));
          //            console.log("Line 1305", data);
          display_product_added()
        }
      })


    }

  }

   // new cart code

  function re_render_cart(cart,response) {
    const parsedHTML = $('<div>').html(response['cart-rendering']);
    // Extract only #cart-inner
    const cartInner = parsedHTML.find('#cart-inner').html();
    const original_price = parsedHTML.find("#subtotal").html();
    const cart_count = parsedHTML.find("#total_items").html();
    const complete_your_look = parsedHTML.find("#cart-complete-the-look-container").html();
    const complete_the_ritual = parsedHTML.find("#cart-complete-the-ritual-container").html();
    const order_summary = parsedHTML.find("#order-summary").html();
    const savings_banner = parsedHTML.find("#savings-banner").html();
    const total_section = parsedHTML.find("#total-section").html();
    $(".cart-count").text(cart.item_count !== 0? cart.item_count:'');
    $('.subtotal').html(`<span class="subtotal">${parseInt(original_price) !== parseInt(cart.items_subtotal_price / 100) ? `<s>&#8377; ${original_price}</s>`:``} &#8377; ${cart.items_subtotal_price / 100} </span>`);
    $('#cart-inner').html(cartInner);
    $('.cart-complete-the-look-container').html(complete_your_look);
    $('.cart-complete-the-ritual-container').html(complete_the_ritual);
    $('.order-summary').html(order_summary);
    $('.savings-banner').html(savings_banner);
    $('.total-section').html(total_section)
    // $('.checkout-btn-container').html(checkout_btn_container)
    if (cart.item_count > 0) {
      $(".cart-empty").hide();
      $(".progressBr").show();
      $(".checkout-form").show();
      $(".cart-actions").show();
      $(".offers-progressBr").show();
      $('.cart-complete-the-look-container').show();
      $('.order-summary').show();
      $('.checkout-btn-container').show();
      $('.cart-complete-the-look-container').show();
      $('.order-summary').show();
      $('.checkout-btn-container').show();
      $('.coupon-box').show();
    }
    else {
      $(".cart-empty").show();
      $(".progressBr").hide();
      $(".checkout-form").hide();
      $(".cart-actions").hide();
      $(".offers-progressBr").hide();
      $('.cart-complete-the-look-container').hide();
      $('.order-summary').hide();
      $('.checkout-btn-container').hide();
      $('.coupon-box').hide();
    }
    if ($('#cart-complete-the-ritual-container .carousel .upsell-card').length === 0) {
      $('.cart-complete-the-ritual-container').hide();
    }
    display_pouch_elegibity(cart);
    if (isClaimPending) {
      isClaimPending = false;
      fireClaimConfetti();
    }
      $('.cartContent').addClass('show2');
      $('body').addClass('overflow');
      $('.body-fade').addClass('active');
  }

  function lockCart() {
    $('body').addClass('cart-locked');
    $('.cart-overlay').addClass('active');
  }

  function unlockCart() {
    $('body').removeClass('cart-locked');
    $('.cart-overlay').removeClass('active');
  }
  function getTotalVariantQty(variantId) {
    let total = 0;
    $('.cart-item').each(function () {
      if ($(this).data('variant-id') == variantId) {
        total += parseInt($(this).find('.qty').text(), 10);
      }
    });
    return total;
  }

  function addToCart_new(variantId,qty,$button,originalHTML) {
    console.log("add to cart function called",new Date())
    var payload = {updates:{}};
    if (qty === undefined){
      qty = 1;
    }
    payload.updates[parseInt(variantId)] = parseInt(qty)

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: payload,
      dataType: 'json',
      success: function (item) {
        console.log("add to cart function response",new Date())
             $.ajax({
              type:"GET",
              url:"/?sections=cart-rendering",
              dataType: 'json',
              success: function(response) {
                console.log("section rendering response",new Date())
                re_render_cart(item,response);
                unlockCart();
                 $button.removeClass('loading').prop('disabled', false).html(originalHTML);
              },
              error: function(error) {
                console.log("error",error);
              }
            });
      },
      error: function(error) {
        isClaimPending = false;
        console.log("error in adding product to cart",error)
      }
    });
  }

  function renderCartLine(item) {
    if ($(`[data-line-key="${item.key}"]`).length) return;
    const html = `
    <div class="single-wish-product cart-item" data-line-key="${item.key}"
       data-variant-id="${item.variant_id}"
       data-qty="${item.quantity}">
    <div class="wish-pd">
      <img src=${item.featured_image.url} alt="">
    </div>
    <div class="wish-content">
      <h4>
        <title>${item.title}</title>
        <span class="remove-item" prd_id="${item.product_id}"var_id="${item.variant_id}" type="prod" sku="${item.sku}" prd_handle="${item.handle}" title="${item.title}" prod_price="${item.price / 100}"  quantity="${item.quantity}" min="0" max="5" style="background:none"><i class="fal fa-times"></i></span>
        <span class="hlk-bdr"></span>
      </h4>
      <div class="wish-btm-content">
        <div class="qty-controls">
            <button class="qty-decrease">−</button>
            <span class="qty">${item.quantity}</span>
            <button class="qty-increase">+</button>
          </div>
        <div class="pric-del">
        <span class="wish-price">${parseInt(item.compare_at_price) > parseInt(item.price) ? `<s>&#8377; ${item.compare_at_price}</s>` : '' } ${parseInt(item.price) / 100}</span>
        </div>
      </div>
    </div>
    </div>
    `;
      $('.cart-inner').prepend(html);
      $(".cart-empty").hide();
      $(".progressBr").show();
      $(".checkout-form").show();
      $(".cart-actions").show();
      display_subtotal();
      $('.cartContent').addClass('show2');
      $('body').addClass('overflow');
  }
 $(document).on('click', '.qty-increase', function () {
  const $item = $(this).closest('.cart-item');
  const key = $item.data('line-key');
  const variantId = $item.data('variant-id');
  const currentQty = parseInt($item.find('.qty').text(), 10);
  const totalQty = getTotalVariantQty(variantId);
  if (totalQty >= 5) return;
  lockCart();
  updateCartLine(key, currentQty + 1, $item);
});

$(document).on('click', '.qty-decrease', function () {
  const $item = $(this).closest('.cart-item');
  const key = $item.data('line-key');
  const currentQty = parseInt($item.find('.qty').text(), 10);
  lockCart();
  if (currentQty === 1) {
    removeCartLine(key, $item[0]);
  } else {
    updateCartLine(key, currentQty - 1, $item);
  }
});

  function changeCartRelatedUI(cart) {
      $(".cart-count").text(cart.item_count !== 0? data.item_count:'');
      if(data.item_count === 0){
        $(".cart-empty").show();
        $(".progressBr").hide();
        $(".checkout-form").hide();
        $(".cart-actions").hide();
        $(".offers-progressBr").hide();
      }
  }

function updateCartLine(key, qty, $item) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: key,
        quantity: qty
      },
      dataType: 'json',
      success: function (data_for_quantity_change) {
        $.ajax({
          type:"GET",
          url:"/?sections=cart-rendering",
          dataType: 'json',
          success: function(response) {
            re_render_cart(data_for_quantity_change,response);
            unlockCart();
          },
          error: function(error) {
            console.log("error",error);
          }
        })
      }
    });
  }
$(document).on('click', '.remove-item', function () {
   const item = $(this).closest('.cart-item');
  const key =  item.data('line-key');
  lockCart();
  removeCartLine(key, item);
});
  function removeCartLine(key, item) {
  // if (!key || !item.length) return;
  console.log("item",item[0]);
  console.log("key",key)
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: key,
      quantity: 0
    },
    dataType: 'json',
    success: function (cart) {
      // remove UI
      $.ajax({
          type:"GET",
          url:"/?sections=cart-rendering",
          dataType: 'json',
          success: function(response) {
            re_render_cart(cart,response)
            //  const parsedHTML = $('<div>').html(response['cart-rendering']);
            // // Extract only #cart-inner
            // const cartInner = parsedHTML.find('#cart-inner').html();
            // const original_price = parsedHTML.find("#subtotal").html();
            // const cart_count = parsedHTML.find("#total_items").html();
            // // Replace only inside your container
            // $(".cart-count").text(data_for_quantity_change.item_count !== 0? data_for_quantity_change.item_count:'');
            // $('.subtotal').html(`<span class="subtotal">${parseInt(original_price) !== parseInt(data_for_quantity_change.items_subtotal_price / 100) ? `<s>&#8377; ${original_price}</s>`:``} &#8377; ${data_for_quantity_change.items_subtotal_price / 100} </span>`);
            // $('#cart-inner').html(cartInner);
            unlockCart();
          },
          error: function(error) {
            console.log("error",error);
          }
        });
    },
    error: function (xhr) {
      console.error('Remove failed:', xhr);
    }
  });
}

  
  $(document).on('click','.add-to-cart.action, .addtocart.action',function(e){
    e.preventDefault()
    /* capture attributes on the clicked element,
    on the index, collection, collection Popup, wishlist and product page */

      if($(this).attr('handle') == 'make-your-own-bundle' || $(this).attr('handle') == 'dynamic-offer-bundlee' || $(this).attr('handle') == '2-products-bundle' || $(this).attr('handle') == 'four-play-glow-on-the-go-combo' || $(this).attr('handle') == 'liquid-lip-and-kajal-combo' || $(this).attr('handle') == 'deal-of-the-day' || $(this).attr('handle') == 'lip-obsession-kit' || $(this).attr('handle') == '2-products-kit' || $(this).attr('handle') == 'build-your-own-bundle' || $(this).attr('handle') == '2-special-products-kit' ){

      if($(this).hasClass('properties-available')){
                // console.log("Getting Dynamic Bundle", $(this))
        var var_id = $(this).attr('vid');
        var prod_id = $(this).attr('pid');
        var type = $(this).attr('type');
        var handle = $(this).attr('handle');
        var quantity;
        if($('body').hasClass('touch-device')){
          quantity = $('.qtybox.prod').find('input').val();
        } else {
          quantity = $('.qtybox.prod.desktop').find('input').val();
        }
        var avail_qty = $(this).attr('avail_qty');
        var $selector = $(this)

        var $bundleselection = $('.bundle.selection');
        //         console.log("Selection", $bundleselection.children());
        add_bundle_to_cart(prod_id,var_id, type, handle, quantity,avail_qty, $selector, $bundleselection);
      } else {
        window.location.href = '/products/' + $(this).attr('handle');
      }
    }

    else if($(this).hasClass('action')){
      var $button = $(this);
      let originalHTML = $button.html();
      $button.addClass('loading').prop('disabled', true).html('Adding...');
      
      var var_id = $(this).attr('vid');
      var prod_id = $(this).attr('pid');
      var type = $(this).attr('type');
      var handle = $(this).attr('handle');
      var quantity;
      if($('body').hasClass('touch-device')){
        quantity = $('.qtybox.prod').find('input').val();
      } else {
        quantity = $('.qtybox.prod.desktop').find('input').val();
      }
      var avail_qty = $(this).attr('avail_qty');
      var $selector = $(this);

      const totalQty = getTotalVariantQty(var_id);

      if (totalQty >= 5) return;
      if (totalQty > 0) {
        if (quantity === undefined || quantity === "undefined") {
          quantity = 1;
        }
        quantity = quantity + totalQty
      }
      // Cart Claim buttons carry the offer code in discountValue
      isClaimPending = !!$(this).attr('discountValue');
      addToCart_new(var_id,quantity,$button,originalHTML);

  }
});

$(document).on('click', '.qtybox .btnqty',function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    var avail_qty = parseInt($(this).parent('.qtybox').find('.quantity-input').attr('max'))
    avail_qty = avail_qty > 5 ? 5 : avail_qty;

    if($(this).parent().hasClass('prod')){
      if($(this).hasClass('qtyplus')) {
        if(qty < avail_qty) {
          qty++;
        }
      }else {
        if(qty > 1) {
          qty--;
        }
      }

      if(qty === avail_qty){
        $(this).closest('.pd-show-content-inner').find('.available.quantity').show()
      } else {
        $(this).closest('.pd-show-content-inner').find('.available.quantity').hide()
      }
      qty = (qty === undefined)? "1" : qty;
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
    }
  })

// $(document).on('click','.non-aff',function(e){
//     e.preventDefault()
//     if($(this).hasClass('non-aff')){
//         // $(this).text("ADDED TO BAG")
//         // $(this).removeClass('action')

//         var dateObj = new Date()
//         var payload = {"date": dateObj.toISOString(),"discount": true}
//         window.localStorage.setItem("discountForm", JSON.stringify(payload))

//         $(".form-checkout").attr('action','https://kirobeauty.com/discount/FREEICONICPOUCH?redirect=/checkout')
//         $(".checkout.cart-checkout").attr('action','https://kirobeauty.com/discount/FREEICONICPOUCH?redirect=/checkout')
//     // }
//   }})


  var get_discountForm = JSON.parse(window.localStorage.getItem('discountForm'))

  if(get_discountForm){
    var get_affiliate_date = new Date(get_discountForm.date)
    var nowdateObj = new Date()
    var diff_date = nowdateObj.getTime() - get_affiliate_date.getTime();
    var diff_day = diff_date / (1000 * 3600 * 24)
    if(parseInt(diff_day) > 0){
      window.localStorage.removeItem('discountForm')
    } else {
      if(get_discountForm['discountValue'])
      $(".form-checkout").attr('action',`https://kirobeauty.com/discount/${get_discountForm['discountValue']}?redirect=/checkout`)
      $(".checkout.cart-checkout").attr(`action','https://kirobeauty.com/discount/${get_discountForm['discountValue']}?redirect=/checkout`)
    }
  }


  $('.wishcart-inner-div').on('click','.delete-cart', function(e){
    // onclick, remove product from cartlist and update
    var vid = $(this).attr('var_id');
    var update_cart = {updates: {}}
    update_cart.updates[parseInt(vid)] = 0

    $.ajax({
      cache: false,
      url: `/cart/update.js`,
      dataType: "json",
      type: "POST",
      data: update_cart,
      success: function(data) {
        setTimeout(function(){display_subtotal()}, 50)
      }
    })  

    remove_cart(vid);
  })

  $(document).find('.color-g-wrap-two').on('click','.checkmark.radio', function(e){
    display_product_added();
  });
  // ----------------------------------------------------  WishList SECTION  ----------------------------------------------------- //

  // -------------------------------------------------------------------------------------------------------- //
  // Query to get customer data
  $(document).ready(function(){
    /*
      * Query Designed to store wishlist and skintone locally and customer DB.
        * Auto Updates when website is accessed. Combines wishlist and skintone on log in and local ends.
        * Handles changes, whether add or remove, locally and log in
    */
    function post_func(cust_id){
      // Create metafield kvsl if metafield doesn't exist.
      // Create AJAX instance

      var post_data = {
        action: "POST",
        customer_id: cust_id,
        post_data: {
          metafield: {
            namespace: "customer",
            key: "wishlist",
            value: window.localStorage.getItem("kvsl"),
            type: "json_string"
          }
        }
      }

      $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://rdq3y0otc0.execute-api.us-east-2.amazonaws.com/dev/metafield`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "oIYMEyyUC83oBMoMdonCq3PVvCrQFQA774k3HsVs");
        },
        data: JSON.stringify(post_data),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      }).done(function(response){
      }).fail();     
    }

    function deduple(wish_meta_data){
      // compare wishlists offline and online,combine, de-duplicate and update offline
      var meta_arr = JSON.parse(wish_meta_data.value)
      var concat_arr = [...ie.wishlist, ...meta_arr.wishlist];

      var update_arr = concat_arr.reduce(function(return_array, val, index, arr){
        var isProduct = return_array.some(item =>(item.vid == val.vid));
        if(!isProduct){
          return_array.push(val);
        }
        return return_array;
      },[])
      var updatelocal = {"wishlist": update_arr}
      window.localStorage.setItem("kvsl", JSON.stringify(updatelocal))
    }

    function put_func(operation, meta_data, cust_id){
      // make sure both offline and online wishlist is updated and the same, update customer metafield
      var wish_meta_data = meta_data.metafields.find(function(val){
        return val.key === "wishlist";
      })
      if (operation === 'Update'){deduple(wish_meta_data);}

      var post_data = {
        action: "PUT",
        customer_id: cust_id,
        post_data: {
          metafield: {
            id: wish_meta_data.id,
            value: window.localStorage.getItem("kvsl"),
            type: "json_string"
          }
        }
      }

      $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://rdq3y0otc0.execute-api.us-east-2.amazonaws.com/dev/metafield`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "oIYMEyyUC83oBMoMdonCq3PVvCrQFQA774k3HsVs");
        },
        data: JSON.stringify(post_data),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      }).done(function(response){
      }).fail();
    }

    function auto_update(operation, cust_id){
      var post_data = {
        action: "GET",
        customer_id: cust_id
      }

      $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://rdq3y0otc0.execute-api.us-east-2.amazonaws.com/dev/metafield`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "oIYMEyyUC83oBMoMdonCq3PVvCrQFQA774k3HsVs");
        },
        data: JSON.stringify(post_data),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      }).done(function(response){
        //           	console.log(response);
        var isWishlist = response.metafields.some((ele) => ele.key === 'wishlist');
        if (!isWishlist){
          post_func(cust_id);
        } else {
          if ( operation === 'Update' ){
            put_func( operation, response ,cust_id)
          } else if( operation === 'Change' ){
            put_func( operation, response ,cust_id)
          }
        }
      }).fail();

    }

    function gen_wish_template(data, value){
      var _img_src, _title, _price, _type, _vid, _shade;

      // render wishlist template on website
      if (value.type === 'prod'){
        // for product level
        _img_src = data.product.image.src;
        _title = data.product.title;
        _price = data.product.variants[0].price;
        _vid = data.product.variants[0].id;
        _type = value.type;
      } else if (value.type === 'var'){
        // for variant level
        data.product.images.forEach(function(ele, index, array){
          if (ele.variant_ids.some(item =>(item === parseInt(value.vid)))){
            _img_src = ele.src;
          }
        });
        data.product.variants.forEach(function(ele, index, array){
          if (ele.id.toString() === value.vid){
            _shade = ele.title;
            _price = ele.price;
          }
        });
        _title = data.product.title;
        _vid = value.vid;
        _type = value.type;
      }
      // this will take the product ID and pull the inventory count from api 

      let product_id = data.product.id
      // this ajax call will get the product inventory quantity
      $.ajax({
        cache: false,
        crossDomain: true,
        url: `https://rdq3y0otc0.execute-api.us-east-2.amazonaws.com/dev/metafield`,
        type: 'POST',
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
          xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("X-Api-Key", "oIYMEyyUC83oBMoMdonCq3PVvCrQFQA774k3HsVs");
        },
        data: JSON.stringify({"product_id_for_inventory":product_id}),
        data_type: 'jsonp',
        contentType: 'application/json',
        async: true
      }).done(function(response){
          console.log("inventory response",response)
          let inventory_count = response;
                var htmlCode = {
                child: `<div class="wish-pd">
                <img src="${_img_src}" alt="">
                </div>
                <div class="wish-content">
                <h4><title>${_title}</title><span class="delete-wish" type=${_type} vid="${_vid}"><i
                class="fal fa-times"></i></span></h4>
                <div class="wish-btm-content">
                ${ value.type === 'var'? `<p><strong>Shade : </strong>${_shade}</p>` :``}
                <div class="pric-del">
                <span class="wish-price"> &#8377; ${_price}</span>
                </div>
                ${inventory_count > 0 ? `<a href="#" class="add-to-cart action wishlist-addcart" tabindex="0" type="${_type}" handle="${value.handle}" vid="${_vid}" fbprodid="${data.product.variants[0].id}" fbname="${data.product.title}" fbcollection="${data.product.product_type}" fbprice="${data.product.variants[0].price}" fbfulname="${data.product.title}" fbsku="${data.product.variants[0].sku}" avail_qty="5"><span>Add to Bag</span></a>` : `<button class="whish-list-sold-out-btn">SOLD OUT</button>`}
                </div>
                </div>`
                      }
                
                      var newElement = document.createElement('div');
                      var att = document.createAttribute("class");       
                      att.value = "single-wish-product";                           
                      newElement.setAttributeNode(att);
                
                      newElement.innerHTML = htmlCode.child;
                      $('.wish-inner-div').prepend(newElement);
      }).fail();
    }

    function gen_wish(value){
      // GET data from product api
      // Create AJAX instance
      $.ajax({
        cache: false,
        url: `/products/${value.handle}`,
        headers: { 'Content-type': 'application/json'},
        async: false,
        type: 'GET',
        dataType: 'json'
      }).done(function(data){
        gen_wish_template(data, value)
      }).fail();
    }

    function add_wish(data){
      // add and update wishlist
      var ie = JSON.parse(window.localStorage.getItem("kvsl"));
      var isProduct = ie.wishlist.some(item =>(item.vid === data.vid) && (item.type === data.type))
      if (!isProduct){
        ie.wishlist.unshift(data)
        window.localStorage.setItem("kvsl",JSON.stringify(ie));
        var arr = [data]
        arr.forEach(gen_wish);
        if (cust_id !== undefined){
          auto_update('Change', cust_id)
        }
      }
    }

    function remove_wish(data){
      // remove and update wishlist
      var wish_arr = Array.from($('.wish-inner-div.wish-list').first().children());
      var ie = JSON.parse(window.localStorage.getItem('kvsl'));
      var idx = wish_arr.findIndex(function(element, index){
        return ($(element).find('.delete-wish').attr('vid') === data.vid);
      });
      var idx2 = ie.wishlist.findIndex(function(element, idx){
        return (element.vid === data.vid);
      });
      ie.wishlist.splice(idx2,1)
      //        var list = document.querySelector('.wish-inner-div.wish-list');
      var $wish_inner = $(document).find('.wish-inner-div.wish-list')
      $wish_inner.each(function(){$(this).children().eq(idx).remove();})
      //         $(document).find('.wish-inner-div.wish-list').children().eq(idx).remove();
      //        list.removeChild(list.childNodes[index]);
      window.localStorage.setItem('kvsl', JSON.stringify(ie));

      if (cust_id !== undefined){
        auto_update('Change', cust_id)
      }
    }

    $(document).on('click',".add-to-cart.action.wishlist-addcart",function(e){
        var vid = $(this).attr('vid');
        var type = $(this).attr('type');
  
        $('.fa-heart.action').each(function(){
          var $selector = $(this)
          var $ele_vid = $selector.attr('vid')
          if($ele_vid === vid){
            $selector.removeClass('fa')
            $selector.addClass('fal')       
          }
        })
  
        $('.add-wish').each(function(){
          var $selector = $(this)
          var $ele_vid = $selector.attr('vid')
          if($ele_vid === vid){
            $selector.removeClass('added')
            $selector.addClass('removed')
            $selector.find('.fa-heart').removeClass('fa')
            $selector.find('.fa-heart').addClass('fal')
            //               $(this).text('ADD TO WISHLIST')
          }
        })  
        remove_wish({"vid":vid,"type":type});
        display_wish_slider_info()
        wish_count()
    })

    $(document).on('click',".fa-heart.action,.add-wish",function(e){
      // Onclick, add to wishlist and update
      e.preventDefault();

      var handle = $(this).attr("handle");
      var vid = $(this).attr("vid");
      var type = $(this).attr("type");
      var append_data = {"handle":handle,"vid":vid,"type":type};

      if(!$(this).hasClass("add-wish")){
        if($(this).hasClass("fa")){
          $(this).removeClass('fa')
          $(this).addClass('fal')
          remove_wish({"vid":vid,"type":type});
          display_wish_slider_info()
          wish_count()

        } else {
          $(this).removeClass('fal')
          $(this).addClass('fa')

          add_wish(append_data)
          display_wish_slider_info()
          wish_count()
        }
      }

      if($(this).hasClass("add-wish")){
        if($(this).hasClass("added")){
          $(this).removeClass('added')
          $(this).addClass('removed')
          remove_wish({"vid":vid,"type":type});
          display_wish_slider_info()
          wish_count()
          //         $(this).text('ADD TO WISHLIST')
          $(this).find('.fa-heart').removeClass('fa')
          $(this).find('.fa-heart').addClass('fal')

        } else {
          $(this).removeClass('removed')
          $(this).addClass('added')

          add_wish(append_data)
          display_wish_slider_info()
          wish_count()
          //         $(this).text('ADDED TO WISHLIST')
          $(this).find('.fa-heart').removeClass('fal')
          $(this).find('.fa-heart').addClass('fa')
        }
      }
    })

    $('.wish-inner-div.wish-list').on('click','.delete-wish', function(e){
      // onclick, remove product from wishlist and update

      var vid = $(this).attr('vid');
      var type = $(this).attr('type');

      $('.fa-heart.action').each(function(){
        var $selector = $(this)
        var $ele_vid = $selector.attr('vid')
        if($ele_vid === vid){
          $selector.removeClass('fa')
          $selector.addClass('fal')       
        }
      })

      $('.add-wish').each(function(){
        var $selector = $(this)
        var $ele_vid = $selector.attr('vid')
        if($ele_vid === vid){
          $selector.removeClass('added')
          $selector.addClass('removed')
          $selector.find('.fa-heart').removeClass('fa')
          $selector.find('.fa-heart').addClass('fal')
          //               $(this).text('ADD TO WISHLIST')
        }
      })  
      remove_wish({"vid":vid,"type":type});
      display_wish_slider_info()
      wish_count()
    })
    //---------------------------------------------------- Run on load --------------------------------------------- //
    var cust_id = $('.cust_init').attr('cid'); // undefined by default, id retrievable when customer logs in
    //window.localStorage.removeItem("kvsl");
    if (window.localStorage.getItem("kvsl") === null) {
      // Auto creates localStorage kvsl  whether customer is logged in or not
      var val = `{"wishlist":[]}`
      window.localStorage.setItem("kvsl",val);
    }
    // Get wishlist locally and render
    var ie = JSON.parse(window.localStorage.getItem("kvsl"));
    display_wish_slider_info()
    $('.fa-heart.action').each(function(){
      var vid = $(this).attr("vid");
      var $selector = $(this)
      ie.wishlist.forEach(function(ele){
        if(ele.vid === vid){
          $selector.removeClass('fal')
          $selector.addClass('fa')
        }
      })                     
    })    
    $('.add-wish').each(function(){
      var vid = $(this).attr("vid");
      var $selector = $(this)
      ie.wishlist.forEach(function(ele){
        if(ele.vid === vid){
          $selector.removeClass('removed')
          $selector.addClass('added')
          $selector.find('.fa-heart').removeClass('fal')
          $selector.find('.fa-heart').addClass('fa')
          //           $selector.text('ADDED TO WISHLIST')
        }
      })
    })
    var reverse_arr = ie.wishlist.map(function(ele){return ele});
    reverse_arr.reverse().forEach(gen_wish);
    wish_count()
    // Get Cart items, handled by Shopify
    $.ajax({
      cache: false,
      url: `/cart.js`,
      dataType: "json",
      type: "GET",
      success: function(data) {
        window.sessionStorage.setItem("kvsl", JSON.stringify(data));    
        // upsell product only if cart has an item
        if(data.items.length !== 0){
          //             cart_upsell(data.items[0].product_id);
        }
        display_product_added()
        display_cart_slider_info()
        display_subtotal()
      }
    })
    if (cust_id !== undefined){
      // when customer is logged in, autoupdate localStorage and online data
      auto_update('Update',cust_id)
    }
    $(".close-over-content").click(function() {
      $(".header-area").addClass('no-skintone');
      $(".section.sec-1").addClass('no-skintone-sections');
      $("main.main-content").addClass('no-skintone-product');
    });
    function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    if(document.referrer !== window.origin+'/'){
      var search = location.search.substring(1);
      var string = '{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}';
      if(isJson(string)){
        var post_data = JSON.parse(string, function(key, value){return key===""?value:decodeURIComponent(value)});
        post_data['url'] = window.location;
        $.ajax({
          cache: false,
          crossDomain: true,
          url: `https://hhajw0obqh.execute-api.us-east-2.amazonaws.com/dev/kiro-analyisis`,
          type: 'POST',
          beforeSend: function(xhr) {
            xhr.setRequestHeader("Access-Control-Allow-Origin", window.origin);
            xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN,Access-Control-Allow-Headers,Access-Control-Allow-Origin");
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader("X-Api-Key", "ieymI1yGjM60oEEJzcNMS2NdK03I7eS23ZyvXMuS");
          },
          data: JSON.stringify(post_data),
          data_type: 'jsonp',
          contentType: 'application/json',
          async: true
        })
      }
    }
  });
})(jQuery);
var acc = document.getElementsByClassName("has-child");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("has-child-active");
    var menu_products = this.nextElementSibling;
    if (menu_products.style.maxHeight) {
      menu_products.style.maxHeight = null;
    } else {
      menu_products.style.maxHeight = menu_products.scrollHeight + "px";
    } 
  });
}
var acc = document.getElementsByClassName("mob-header-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
// window.onload = function() {
//   var pageTitle = document.title;
//   var attentionMessage = 'Kiro Clean Beauty';
//   document.addEventListener('visibilitychange', function(e) {
//     var isPageActive = !document.hidden;
//     if(!isPageActive){
//       document.title = attentionMessage;
//     }else {
//       document.title = pageTitle;
//     }
//   });
// };